<template>
  <div class="row">
    <div class="col-sm-12 col-md-8">
      <div class="pos-leftbar" id="pos-leftbar">
        <div class="pos-header">
          <div class="mb-1">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <input
                    type="text"
                    v-model="querySearchCode"
                    class="form-control"
                    placeholder="Appointment ID / Customer ID"
                    @keyup.enter="appointmentSearchByCode"
                    @input="appointmentSearchByCode"
                  />
                </div>
              </div>
              <!-- <div :class="(form.customer_id == 1) ? 'col-md-8' : 'col-md-12'">
                <div class="input-group input-group-merge"> 
                  <Multiselect
                    class="form-control border customer_id"
                    mode="single"
                    v-model="form.customer_id"
                    placeholder="Patient"
                    @change="selectCustomer($event)"
                    :searchable="true"
                    :filter-results="true"
                    :options="state.customers"
                    :classes="multiclasses"
                    :close-on-select="true"
                    :min-chars="1"
                    :resolve-on-load="false"
                  />
                </div>
              </div> -->
              <div class="col-md-8">
                <div class="input-group input-group-merge"> 
                  <input type="hidden" v-model="form.customer_id" class="form-control">
                  <input type="text" v-model="form.patient_name" class="form-control">
                </div>
              </div>
            </div>
          </div>

          <div class="mb-1">
            <div class="input-group input-group-merge autocomplete">
              <input
                type="text"
                v-model="searchItem"
                class="form-control"
                placeholder="Scan/Search product by name/code"
                @keyup="searchPosProducts"
                @keyup.enter="addProductToCart()"
                @keydown.down="onArrowDown"
                @keydown.up="onArrowUp"
              />
              <!-- <div class="input-group-text">
                <a @click="barcodeReaderModal">
                  <i class="fas fa-2x fa-camera"></i>
                </a>
              </div> -->
              <ul
                v-if="searchProduct.length"
                class="
                  w-full
                  rounded
                  bg-white
                  border border-gray-300
                  px-2
                  py-2
                  space-y-1
                  absolute
                  z-10
                  autocomplete-results
                "
              >
                <li class="px-1 pt-1 pb-2 font-bold border-b border-gray-200">
                  <div style="width: 100%">
                    <div style="width: 40%; float: left; font-size: 10px">
                      Product name
                    </div>
                    <div style="width: 25%; float: left; font-size: 10px">
                      Generic name
                    </div>
                    <div style="width: 15%; float: left; font-size: 10px">
                      Company/Brand
                    </div>
                    <div
                      style="
                        width: 20%;
                        float: right;
                        font-size: 10px;
                        text-align: right;
                      "
                    >
                      Expire Date
                    </div>
                  </div>
                </li>
                <li
                  v-for="(item, i) in searchProduct.slice(0, 15)"
                  :key="item.product_name"
                  @change="selectProduct(item)"
                  @click="setResult(item)"
                  class="cursor-pointer hover:bg-gray-100 p-1"
                  :class="{ isActive: i === arrowCounter }"
                >
                  <div style="width: 100%; display: inline-block;">
                    <div style="width: 40%; float: left;">
                      <strong style="font-size: 12px"
                        >{{ item.product_name }} ({{ item.product_code }})</strong
                      >
                    </div>  
                    <div style="width: 25%; float: left;">
                      <span style=""
                          >{{ item.product_native_name }}
                      </span>
                    </div>  
                    <div style="width: 15%; float: left;">
                      <span style=""
                        >{{ item.brand_name ? item.brand_name : "" }}</span
                      >
                    </div>  
                    <div style="width: 20%; float: left;">
                      <span
                        v-if="item.expires_date"
                        style="
                          color: rgb(34, 5, 242);
                          float: right;
                          text-align: right;
                        "
                      >
                        {{ item.expires_date ? item.expires_date : "" }}
                      </span>
                    </div>  
                  </div>                  
                </li>
              </ul>
            </div>
          </div>            
        </div>
        <div
          class="pos-body scrollbar-width-thin"
          v-bind:style="{ height: winSize.height + 'px' }"
        >
          <div class="">
            <table
              id="header-fixed"
              class="
                table-sm
                pos-table
                table
                items
                table-striped table-bordered table-condensed table-hover
                sortable_table
              "
            >
              <thead class="tableFloatingHeaderOriginal">
                <tr class="border item-head">
                  <th width="30%">Item Name</th>
                  <th width="10%" class="text-center">Stock Qty</th>
                  <th width="10%" class="text-center">UOM</th>
                  <th width="10%" class="text-center">Qty</th>
                  <!-- <th width="10%" class="text-center">Weight</th> -->
                  <th width="10%" class="text-center">Price</th> 
                  <th width="10%" class="text-center">Value</th> 
                  <th width="10%" class="text-center">Plat Disc. </th> 
                  <th width="10%" class="text-center">Disc %
                    <input
                      class="form-control discount_percent"
                      v-model="items_discount_percent"
                      type="number"
                      @change="allItemDiscountPercent()"
                      style="text-align: center"
                    />
                  </th> 
                  <th width="10%" class="text-center">Disc Value</th> 
                  <th width="15%" class="text-center">Net Value</th>
                  <th width="5%">Action</th>
                </tr>
              </thead>
              <tr
                class="border"
                v-for="(item, i) in presCartItems"
                v-if="presCartItems.length > 0"
                :key="item.id"
              >
                <td class="text-left p-1">
                  {{ item.product_name }} ({{ item.product_code }}) ({{
                    item.expires_date
                  }}) <span v-if="item.product_name.length > 30">...</span>
                </td>
                <td class="text-center border">
                  {{ item.stock_quantity }}
                </td>
                <td class="tableitem">
                  <select class="form-control border" v-model="item.uom">
                    <option
                      :value="unit.id"
                      v-for="(unit, i) in state.units"
                      :key="i"
                    >
                      {{ unit.unit_code }}
                    </option>
                  </select>
                </td>
                <td class="text-center border">
                  <input
                    class="form-control qty "
                    type="number"
                    name=""
                    v-model="item.quantity"
                    @keyup="checkStockQty(item)"
                    style="text-align: center"
                  />
                </td>
                <!-- <td class="text-center border">
                  <input
                    class="form-control qty"
                    type="number"
                    name=""
                    v-model="item.weight"
                    style="text-align: center"
                  />
                </td> -->
                <!-- <td class="text-center border">{{ item.mrp_price }}</td> -->
                <td class="text-center border">
                  
                  <!-- @change="itemDiscountPlat(item, i)" -->
                  <input
                    class="form-control qty"
                    type="number"
                    name=""
                    v-model="item.mrp_price"
                    style="text-align: center"
                  /> 
                </td>
                <td class="text-center border">{{
                    item.uom == 5
                      ? parseFloat(
                          item.mrp_price * item.weight 
                        ).toFixed(0)
                      : parseFloat(
                          item.mrp_price * item.quantity  
                        ).toFixed(2)
                  }}</td>
                
                <td class="text-center border">
                <input
                    class="form-control qty"
                    type="number"
                    name=""
                    v-model="item.discount"
                    @change="itemDiscountPlat(item, i)"
                    style="text-align: center"
                  /> </td> 
                <td class="text-center border">
                <input
                    class="form-control qty"
                    v-model="item.discount_percent"
                    type="number"
                    name="" 
                    @change="itemDiscountPercent(item, i)"
                    style="text-align: center"
                  /> </td> 
                <td class="text-center border">
                  {{
                    item.uom == 5
                      ? parseFloat(
                           (item.discount * item.weight)
                        ).toFixed(2)
                      : parseFloat(
                           (item.discount * item.quantity)
                        ).toFixed(2)
                  }}
                </td>
                <td class="text-center border">
                  {{
                    item.uom == 5
                      ? parseFloat(
                          item.mrp_price * item.weight - (item.discount * item.weight)
                        ).toFixed(2)
                      : parseFloat(
                          item.mrp_price * item.quantity - (item.discount * item.quantity)
                        ).toFixed(2)
                  }}
                </td>
                
                <td @click="removePresSaleCartItem(i)" style="text-align: center">
                  <i
                    style="font-size: 20px; cursor: pointer; color: #ff6a00"
                    class="mdi mdi-trash-can-outline"
                  ></i>
                </td>
              </tr>

              <tr class="border">
                <td class="text-left p-1"> </td>
                <td class="tableitem"> </td>
                <td class="tableitem"> </td>
                <td class="text-center border">{{parseFloat(totalItemQty).toFixed(0)}} </td>
                <td class="text-center border">{{parseFloat(totalItemWeight).toFixed(3)}}</td>  
                <td class="text-center border">{{parseFloat(totalItemPrice).toFixed(2)}}</td>  
                <td class="text-center border">{{parseFloat(totalItemValue).toFixed(2)}}</td>
                <td class="text-center border"></td>
                <td class="text-center border"></td>
                <td class="text-center border">{{parseFloat(totalItemDiscountValue).toFixed(2)}}</td>
                <td class="text-center border">{{parseFloat(totalItemNetValue).toFixed(2)}}</td>
                <td  style="text-align: center"> 
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-md-4">
      <!-- <div class="row">
          <div class="form-group col-md-12">
              <label for="cost_center_id" style="width: 100%;">Cost Centers *</label>
              <treeselect 
                  v-model="form.cost_center_id"
                  :multiple="false" 
                  :always-open="false"
                  :options="costCenterOptions"
                  :value-consists-of="valueConsistsOf"
                  :normalizer="normalizer"
                  :default-expand-level="Infinity"
                  :disable-branch-nodes="true"
                  :search-nested="true"                                                
                  placeholder='Select Cost Center'
                  v-if="renderOptionComponent"
              />
              <div class="invalid-feedback" v-if="errors.cost_center_id">
                  {{ errors.cost_center_id[0] }}
              </div>
          </div>
      </div> -->
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for="amount_0">Given Amount</label>
            <input
              v-model="pform.payments[0].amount"
              id="amount_0"
              type="text"
              class="form-control"
              ref="amount_0"
              @keyup="checkAboveAmount($event, 's')"
              @keypress="validateNumber"
            />
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label for="paid_by">Paying by</label>
            <select
              class="form-control border"
              id="payingby_0"
              v-model="pform.payments[0].paid_by"
              @change="payingByAnother($event, 0)"
            >
              <option
                v-for="(item, key, index) in paying_by"
                :key="key"
                :value="item.value"
                :disabled="checkItem(item.value)"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
        <!-- <div class="col-sm-2">
          <div class="form-group">
            <button>dd</button>
          </div>
        </div> -->
      </div>
      <div class="row">
        <div class="row pt-2"></div>
      </div>
      <div class="row">
        <div>
          <table
            class="table-sm table table-bordered border"
            style="margin-bottom: 0px"
          >
            <thead class="tableFloatingHeaderOriginal">
              <tr class="border item-head return_amount" >
                <th >Return Amount</th>
                <th :id="(Number(netAmountCalculate - totalCollections) < 0) ? 'return_amount': ''">
                <span v-if="(Number(netAmountCalculate - totalCollections) < 0)">
                  {{  Math.abs(Number(netAmountCalculate - totalCollections)).toLocaleString() }}
                </span> 
                <span v-else>
                  0
                </span> 
                </th> 
                <th
                  rowspan="7"
                  class="text-center align-middle border fc-darkblue"
                  bgcolor="green"
                >
                  <p style="font-size: 20px">
                    Net Amount <br />
                    {{ netAmountCalculate }}
                  </p>
                </th>
              </tr>
              <tr class="border item-head">
                <th>Total</th>
                <th>{{ Number(Math.abs(totalCartValue)).toLocaleString() }}</th> 
              </tr>
              <tr class="item-head">
                <th>Special Customer & Group Discount</th>
                <th>
                  {{
                    Math.round(Number(
                      customer_discount + customer_group_discount
                    )).toLocaleString()
                  }}
                </th>
              </tr>
              <!-- <tr class="item-head"> 
                  <th>Special customer  </th>
                  <th>{{Number(customer_group_discount).toLocaleString()}} </th> 
                </tr> -->
              <tr class="item-head">
                <th>Discount & Coupon</th>
                <th>
                  {{
                    Number(
                      special_discount + couponDiscoun 
                    ).toLocaleString()
                  }}
                </th>
              </tr>
              <tr class="item-head">
                <th>Item Discount</th>
                <th>{{ Number(cartItemDiscount).toLocaleString() }}</th>
              </tr>
              <tr class="item-head">
                <th>Invoice VAT & Item VAT</th>
                <th>
                  {{ Number(invoiceVat + totalCartTax).toLocaleString() }}
                </th>
              </tr>
              <!-- <tr class="  item-head">
                  <th></th>
                  <th>{{Number(totalCartTax).toLocaleString()}}</th> 
                </tr> -->
              <tr class="item-head">
                <th>Total Item</th>
                <th>{{ Number(presCartItems.length).toLocaleString() }}</th>
              </tr>
            </thead>
          </table>
        </div>

        <div class="row button-list pt-2">
          <div class="col-md-8 coupon_box" style="padding: 0px 0px 0px 8px">
            <div class="d-grid">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control border coupon"
                  v-model="form.coupons_code"
                  placeholder="Enter Coupon Code"
                  autocomplete="off"
                  autofocus="off"
                />
                <button type="button" class="btn btn-sm btn-primary" @click="applyCoupons">
                  <i v-show="couponSubmit" class="fas fa-spinner fa-spin"></i>
                  Apply Coupon
                </button>
              </div>
            </div>
          </div>
          <div
            class="col-xs-12 col-sm-6 col-md-4 action_btn"
            style="padding: 0 5px"
          >
            <div class="d-grid">
              <button
                type="button"
                class="btn btn-sm btn-success"
                @click="addDiscountModal"
              >
                Add Discount
              </button>
            </div>
          </div>
          <div
            class="col-xs-12 col-sm-6 col-md-4 action_btn"
            style="padding: 0"
          >
            <div class="d-grid">
              <button
                type="button"
                class="btn btn-sm btn-primary"
                @click="handleSaleHoldSubmit"
                :disabled="disabled"
              >
                Hold
              </button>
            </div>
          </div>
          <div
            class="col-xs-12 col-sm-6 col-md-4 action_btn"
            style="padding: 0 0px"
          >
            <div class="d-grid">
              <button
                type="button"
                class="btn btn-sm btn-danger"
                id="reset"
                @click="clearAllCartItems"
              >
                Clear Item
              </button>
            </div>
          </div>
          <div
            class="col-xs-12 col-sm-6 col-md-4 action_btn"
            style="padding: 0 5px"
          >
            <div class="d-grid">
              <button
                type="button" 
                class="btn btn-sm btn-success"
                @click="addConfirmModal"
                :disabled="submitDisable" 
              >
                Confirm
              </button>
            </div>
          </div>

          <div
            class="col-xs-12 col-sm-6 col-md-4 action_btn"
            style="padding: 0"
          >
            <div class="d-grid">
              <button
                type="button"
                class="btn btn-sm btn-primary"
                @click="rePrintModal"
              >
                Reprint
              </button>
            </div>
          </div>
          <!-- <div class="col-md-4 " style="padding: 0;">
              <div class="d-grid">                 
                <button type="button" class="btn btn-sm btn-info" @click="saleReplaceModal" >
                Replace </button> 
              </div> 
            </div> -->
          <div
            class="col-xs-12 col-sm-6 col-md-4 action_btn"
            style="padding: 0"
          >
            <div class="d-grid">
              <button
                type="button"
                class="btn btn-sm btn-warning"
                @click="returnReplaceModal"
              >
                Return
              </button>
            </div>
          </div>
          <div
            class="col-xs-12 col-sm-6 col-md-4 action_btn"
            style="padding: 0"
          >
            <div class="d-grid">
              <!-- <button type="button" class="btn btn-sm btn-warning" @click="invoiceModal">Invoice preview</button>  -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <Modal @close="paymentModal()" :modalActive="paymentModalActive">
      <div class="modal-content scrollbar-width-thin">
        <div class="modal-header">
          <h5>Multi payment option</h5>
          <button @click="paymentModal()" type="button" class="btn btn-default">
            X
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-6">
              <p v-if="customer && customer.customer_group_name != 'Walking Customer'">
                Available Points : {{ customer.points }} = ৳
                {{
                  parseFloat(
                    Number(convartRate * customer.points).toLocaleString()
                  ).toFixed(2)
                }}
              </p>
            </div>
            <div class="col-lg-6"></div>
            <div class="col-lg-6">
              <div class="mb-3">
                <textarea
                  data-toggle="maxlength"
                  v-model="pform.sale_note"
                  class="form-control"
                  maxlength="225"
                  rows="2"
                  placeholder="Sale Note"
                ></textarea>
              </div>
            </div>
            <!-- end col -->
            <div class="col-lg-6">
              <div class="mb-3">
                <textarea
                  data-toggle="maxlength"
                  v-model="pform.staff_note"
                  class="form-control"
                  maxlength="225"
                  rows="2"
                  placeholder="Staff Note"
                ></textarea>
              </div>
            </div>
            <!-- end col -->
          </div>
          <div class="payment well well-sm">
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="amount_0">Amount</label>
                  <input
                    v-model="pform.payments[0].amount"
                    id="amount_0"
                    type="text"
                    class="form-control"
                    ref="amount_0"
                    @keyup="checkAboveAmount($event, 's')"
                    @keypress="validateNumber"
                  />
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="paid_by">Paying by2</label>
                  <select
                    class="form-control border"
                    id="payingby_0"
                    v-model="pform.payments[0].paid_by"
                    @change="payingBy($event, 0)"
                  >
                    <option
                      v-for="(item, key, index) in paying_by"
                      :key="key"
                      :value="item.value"
                      :disabled="checkItem(item.value)"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div
                  class="form-group"
                  v-if="pform.payments[0].paid_by == 'redeem_point'"
                >
                  <label for="gift_card_no_1">Redeem point</label>
                  <input
                    v-model="pform.payments[0].redeem_point"
                    type="text"
                    class="form-control"
                    @keyup="redeemPointCheck($event, 0)"
                  />
                </div>
                <div
                  class="form-group"
                  v-if="pform.payments[0].paid_by == 'gift_card'"
                >
                  <label for="gift_card_no_1">Gift Card No</label>
                  <input
                    v-model="pform.payments[0].gift_card"
                    type="text"
                    class="form-control"
                  />
                </div>
                <div class="row" v-if="pform.payments[0].paid_by == 'CC'">
                  <div class="form-group col-sm-6">
                    <label for="gift_card_no_1">Card Reference Code</label>
                    <input
                      v-model="pform.payments[0].card_reference_code"
                      type="text"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="gift_card_no_1">Bank Name</label>
                    <select
                      class="form-control border"
                      v-model="pform.payments[0].bank_id"
                    >
                      <option
                        v-for="(bank, index) in state.banks"
                        :value="bank.id"
                        :key="index"
                      >
                        {{ bank.bank_name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div
                  class="row"
                  v-if="pform.payments[0].paid_by == 'mfs'"
                >
                  <div class="form-group col-sm-12">
                    <label for="gift_card_no_1">Mobile wallet Name</label>
                    <select
                      class="form-control border"
                      v-model="pform.payments[0].wallet_id"
                    >
                      <option
                        v-for="(wallet, index) in state.wallets"
                        :value="wallet.id"
                        :key="index"
                      >
                        {{ wallet.mobile_wallet }}
                      </option>
                    </select>
                  </div>

                  <div class="form-group col-sm-6">
                    <label for="gift_card_no_1">Transaction No</label>
                    <input
                      v-model="pform.payments[0].transaction_no"
                      type="text"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="gift_card_no_1">Bank Name</label>
                    <select
                      class="form-control border"
                      v-model="pform.payments[0].bank_id"
                    >
                      <option
                        v-for="(bank, index) in state.banks"
                        :value="bank.id"
                        :key="index"
                      >
                        {{ bank.bank_name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <label for="amount_1">Payment Note</label>
                  <textarea
                    data-toggle="maxlength"
                    v-model="pform.payments[0].payment_note"
                    class="form-control"
                    maxlength="225"
                    rows="2"
                    placeholder="Sale Note"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div
            class="payment well well-sm mt-2"
            v-for="(item, i) in more_payemnts"
            v-if="more_payemnts.length > 0"
            :key="item.id"
            >
            <div class="row">
              <div class="float-right">
                <button
                  type="button"
                  class="btn-primary float-right"
                  @click="morePayemntRemove(i)"
                >
                  X
                </button>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="amount_1">Amount</label>
                  <input
                    v-model="pform.payments[i + 1].amount"
                    :id="'amount_' + parseFloat(i + 1)"
                    type="text"
                    class="form-control"
                    ref="'amount_'+parseFloat(i+1)"
                    @keyup="checkAboveAmount($event, i)"
                    @keypress="validateNumber"
                  />
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="paid_by">Paying by3</label>
                  <select
                    class="form-control border"
                    :id="'payingby_' + parseFloat(i + 1)"
                    v-model="pform.payments[i + 1].paid_by"
                    @change="payingBy($event, i + 1)"
                  >
                    <option
                      v-for="(item, key, index) in paying_by"
                      :key="key"
                      :value="item.value"
                      :disabled="checkItem(item.value)"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div
                  class="form-group"
                  v-if="pform.payments[i + 1].paid_by == 'redeem_point'"
                >
                  <label for="gift_card_no_1">Redeem point</label>
                  <input
                    v-model="pform.payments[i + 1].redeem_point"
                    type="text"
                    class="form-control"
                    @keyup="redeemPointCheck($event, i + 1)"
                  />
                </div>
                <div
                  class="form-group"
                  v-if="pform.payments[i + 1].paid_by == 'gift_card'"
                >
                  <label for="gift_card_no_1">Gift Card No</label>
                  <input
                    v-model="pform.payments[i + 1].gift_card"
                    type="text"
                    class="form-control"
                  />
                </div>
                <div class="row" v-if="pform.payments[i + 1].paid_by == 'CC'">
                  <div class="form-group col-sm-6">
                    <label for="gift_card_no_1">Card Reference Code</label>
                    <input
                      v-model="pform.payments[i + 1].card_reference_code"
                      type="text"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="gift_card_no_1">Bank Name</label>
                    <select
                      class="form-control border"
                      v-model="pform.payments[i + 1].bank_id"
                    >
                      <option
                        v-for="(bank, index) in state.banks"
                        :value="bank.id"
                        :key="index"
                      >
                        {{ bank.bank_name }}
                      </option>
                    </select>
                  </div>
                </div>
                
                <div
                  class="row"
                  v-if="pform.payments[i + 1].paid_by == 'mfs'"
                >
                  <div class="form-group col-sm-12">
                    <label for="gift_card_no_1">Mobile wallet Name</label>
                    <select
                      class="form-control border"
                      v-model="pform.payments[i + 1].wallet_id"
                    >
                      <option
                        v-for="(wallet, index) in state.wallets"
                        :value="wallet.id"
                        :key="index"
                      >
                        {{ wallet.mobile_wallet }}
                      </option>
                    </select>
                  </div>

                  <div class="form-group col-sm-6">
                    <label for="gift_card_no_1">Transaction No</label>
                    <input
                      v-model="pform.payments[i + 1].transaction_no"
                      type="text"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="gift_card_no_1">Bank Name</label>
                    <select
                      class="form-control border"
                      v-model="pform.payments[i + 1].bank_id"
                    >
                      <option
                        v-for="(bank, index) in state.banks"
                        :value="bank.id"
                        :key="index"
                      >
                        {{ bank.bank_name }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="form-group">
                  <label for="amount_1">Payment Note</label>
                  <textarea
                    data-toggle="maxlength"
                    v-model="pform.payments[i + 1].payment_note"
                    class="form-control"
                    maxlength="225"
                    rows="2"
                    placeholder="Sale Note"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="row pt-2">
            <div class="d-grid">
              <button
                type="button"
                class="btn btn-primary"
                @click="morePayemnt()"
              >
                <i class="fa fa-plus"></i> Add More Payments
              </button>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary"
            @click="handleSubmit"
            :disabled="disabled"
          >
            <span v-show="isSubmit" :disabled="disabled">
              <i class="fas fa-spinner fa-spin"></i>
            </span>
            Submit
          </button>
        </div>
      </div>
    </Modal>

    <!-- Customer Add Modal -->
    <Modal @close="customerModal()" :modalActive="customerModalActive">
      <div class="modal-content scrollbar-width-thin customer-add-modal">
        <div class="modal-header">
          <h5>Add New Customer</h5>
          <button
            @click="customerModal()"
            type="button"
            class="btn btn-default"
          >
            X
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-4">
              <div class="mb-3">
                <label for="customer_code" class="form-label" >Customer Code *</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control border"
                    @keypress="onkeyPress('customer_code')"
                    v-model="cform.customer_code"
                    id="product_code"
                    placeholder="Customer Code"
                    autocomplete="off"
                  />
                  <span
                    class="input-group-text"
                    id="random_num"
                    @click="random_num()"
                  >
                    <i class="fa fa-random"></i>
                  </span>
                  <div class="invalid-feedback" v-if="errors.customer_code">
                    {{ errors.customer_code[0] }}
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="col-lg-4">
              <div class="mb-3">
                <label for="emp_code" class="form-label" >EMP ID</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control border"
                    @keypress="onkeyPress('emp_code')"
                    v-model="cform.emp_code"
                    id="product_code"
                    placeholder="EMP ID"
                    autocomplete="off"
                  /> 
                  <div class="invalid-feedback" v-if="errors.emp_code">
                    {{ errors.emp_code[0] }}
                  </div>
                </div>
              </div>
            </div> -->
            <!-- end col -->
            <div class="col-lg-4" style="display: none">
              <div class="mb-3">
                <label for="company_id" class="form-label">Company </label>
                <select
                  class="form-control border"
                  v-model="cform.company_id"
                  @change="onkeyPress('company_id')"
                  id="company_id"
                >
                  <option value="0">Select company</option>
                  <option
                    v-for="(company, index) in state.companies"
                    :value="company.id"
                    :key="index"
                  >
                    {{ company.name }}
                  </option>
                </select>
                <div class="invalid-feedback" v-if="errors.company_id">
                  {{ errors.company_id[0] }}
                </div>
              </div>
            </div>
            <!-- end col -->
            <div class="col-lg-4">
              <div class="mb-3">
                <label for="customer_group_id" class="form-label"
                  >Customer Group *</label
                >
                <select
                  class="form-control border"
                  v-model="cform.customer_group_id"
                  @change="onkeyPress('customer_group_id')"
                  id="customer_group_id"
                >
                  <option value="0">Select Customer Group</option>
                  <option
                    v-for="(c_group, index) in state.customer_groups"
                    :value="c_group.id"
                    :key="index"
                  >
                    {{ c_group.title }}
                  </option>
                </select>
                <div class="invalid-feedback" v-if="errors.customer_group_id">
                  {{ errors.customer_group_id[0] }}
                </div>
              </div>
            </div>
            <!-- end col -->
          </div>
          <div class="row">
            <div class="col-lg-4">
              <div class="mb-3">
                <label for="name" class="form-label">Name *</label>
                <input
                  type="text"
                  class="form-control"
                  @keypress="onkeyPress('name')"
                  @keyup="ledgerAccountNameSetup($event.target.value)"
                  v-model="cform.name"
                  id="name"
                  placeholder="Customer Name"
                  autocomplete="off"
                />
                <div class="invalid-feedback" v-if="errors.name">
                  {{ errors.name[0] }}
                </div>
              </div>
            </div>
          
            <div class="col-lg-4">
              <div class="mb-3">
                <label for="phone" class="form-label">Phone Number *</label>
                <input
                  type="text"
                  class="form-control"
                  @keypress="onkeyPress('phone')"
                  v-model="cform.phone"
                  id="phone"
                  placeholder="Mobile number"
                />
                <div class="invalid-feedback" v-if="errors.phone">
                  {{ errors.phone[0] }}
                </div>
              </div>
            </div>

            <div class="col-lg-4">
              <label for="gender" class="form-label">Gender</label>
              <select 
                id="gender" 
                class="form-control" 
                v-model="cform.gender">
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
              <div class="invalid-feedback" v-if="errors.gender">
                {{ errors.gender[0] }}
              </div>
            </div>

            <!-- end col -->
            <div class="col-lg-4">
              <div class="mb-3">
                <label for="email" class="form-label">Email </label>
                <input
                  type="text"
                  class="form-control"
                  @keypress="onkeyPress('email')"
                  v-model="cform.email"
                  id="email"
                  placeholder="Customer Email"
                  autocomplete="off"
                />
                <div class="invalid-feedback" v-if="errors.email">
                  {{ errors.email[0] }}
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="mb-3">
                <label for="dob" class="form-label">Date of Birth </label>
                <input
                  type="date"
                  class="form-control"
                  @keypress="onkeyPress('dob')"
                  v-model="cform.dob"
                  id="dob"
                  placeholder=""
                  autocomplete="off"
                />
                <div class="invalid-feedback" v-if="errors.dob">
                  {{ errors.dob[0] }}
                </div>
              </div>
            </div>
            <div class=" col-lg-4">
              <label for="discount_percent" class="form-label"
                >Discount Percent
              </label>
              <input
                type="number"
                class="form-control"
                v-model="cform.discount_percent"
                id="discount_percent"
                placeholder="Discount Percent"
                autocomplete="off"
              />
              <div class="invalid-feedback" v-if="errors.discount_percent">
                {{ errors.discount_percent[0] }}
              </div>
            </div>
          </div> 
          <div class="row">
            <div class="form-group col-md-3">
              <label for="district_id" class="form-label">District</label>
              <select
                class="form-control border"
                v-model="cform.district_id"
                id="district_id"
                @change="districtChange($event)"
              >
                <option value="0">Select district</option>
                <option
                  v-for="(district, index) in state.districts"
                  :value="district.id"
                  :key="index"
                >
                  {{ district.name }}
                </option>
              </select>
              <div class="invalid-feedback" v-if="errors.district_id">
                {{ errors.district_id[0] }}
              </div>
            </div>
            <div class="form-group col-md-3">
              <label for="area_id" class="form-label">Area</label>
              <select
                class="form-control border"
                v-model="cform.area_id"
                id="area_id"
              >
                <option value="0">Select area</option>
                <option
                  v-for="(area, index) in state.areas"
                  :value="area.id"
                  :key="index"
                >
                  {{ area.name }}
                </option>
              </select>
              <div class="invalid-feedback" v-if="errors.area_id">
                {{ errors.area_id[0] }}
              </div>
            </div>
            <div class="form-group col-md-3">
              <label for="postal_code" class="form-label">Postal Code</label>
              <input
                type="text"
                class="form-control border"
                v-model="cform.postal_code"
                id="postal_code"
                placeholder="Postal Code"
                autocomplete="off"
              />
              <div class="invalid-feedback" v-if="errors.postal_code">
                {{ errors.postal_code[0] }}
              </div>
            </div> 
            <div class="form-group col-md-3">
              <div class="mb-3">
                <label for="example-select" class="form-label">Status </label>
                <select class="form-select" v-model="cform.status">
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </div>
              <div class="invalid-feedback" v-if="errors.status">
                {{ errors.status[0] }}
              </div>
            </div>
          </div>

          <!-- <div class="row">
            <div class="form-group form-check col-md-3">
              <input
                type="checkbox"
                class="form-check-input"
                true-value="1"
                false-value="0"
                v-model="cform.wholesale_customer"
                id="wholesale_customer"
              />
              Wholesale Customer
              <div class="invalid-feedback" v-if="errors.wholesale_customer">
                {{ errors.wholesale_customer[0] }}
              </div>
            </div>
            <div class="form-group form-check col-md-3">
              <input
                type="checkbox"
                class="form-check-input"
                true-value="1"
                false-value="0"
                v-model="cform.sale_without_vat"
                id="sale_without_vat"
              />
              Sale Without VAT
              <div class="invalid-feedback" v-if="errors.sale_without_vat">
                {{ errors.sale_without_vat[0] }}
              </div>
            </div>
            <div class="form-group form-check col-md-3">
              <input
                type="checkbox"
                class="form-check-input"
                true-value="1"
                false-value="0"
                v-model="cform.credit_customer"
                id="credit_customer"
              />
              Credit Customer
              <div class="invalid-feedback" v-if="errors.credit_customer">
                {{ errors.credit_customer[0] }}
              </div>
            </div>
            <div class="form-group form-check col-md-3">
              <input
                type="checkbox"
                class="form-check-input"
                true-value="1"
                false-value="0"
                v-model="cform.store_customer"
                id="store_customer"
              />
              Store Customer
              <div class="invalid-feedback" v-if="errors.store_customer">
                {{ errors.store_customer[0] }}
              </div>
            </div>
          </div> -->
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary" @click="handleCustomer">
            <span v-show="isSubmit" :disabled="disabledCBtn">
              <i class="fas fa-spinner fa-spin"></i>
            </span>
            Submit
          </button>
        </div>
      </div>
    </Modal>

    <Modal @close="addDiscountModal()" :modalActive="discountModalActive">
      <div class="modal-content scrollbar-width-thin">
        <div class="modal-header">
          <h5>Add Discount</h5>
          <button
            @click="addDiscountModal()"
            type="button"
            class="btn btn-default"
          >
            X
          </button>
        </div>
        <div class="modal-body">
          <!-- v-if="!enabledDiscount" -->
          <div class="row" style="display:none">
            <div class="col-lg-12">
              <div class="mb-3">
                <label for="customer_group_id" class="form-label"
                  >User ID *</label
                >
                <input
                  type="text"
                  class="form-control border"
                  v-model="user.email"
                  placeholder="User ID"
                  autocomplete="off"
                />
              </div>
            </div>
            <!-- end col -->
            <div class="col-lg-12">
              <div class="mb-3">
                <label for="customer_group_id" class="form-label"
                  >Password *</label
                >
                <input
                  type="password"
                  class="form-control border"
                  v-model="user.password"
                  placeholder="Password"
                  autocomplete="off"
                />
              </div>
            </div>
            <!-- end col -->
          </div>
          <div class="row" >
            <div class="col-lg-12">
              <div class="mb-3">
                <label for="orderDiscount">Discount (5 or 5%) </label>
                <input
                  type="text"
                  class="form-control border"
                  v-model="form.order_discount"
                  placeholder="5 or 5%"
                  autocomplete="off"
                />
              </div>
            </div>
            <!-- end col -->
          </div>
        </div>
        <div class="modal-footer">
          <button style="display:none" 
            type="submit"
            class="btn btn-primary"
            @click="handleLogin"
            v-if="!enabledDiscount"
          >
            <span v-show="isSubmit" :disabled="disabled">
              <i class="fas fa-spinner fa-spin"></i> </span
            >Submit
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            @click="addDiscountModal" 
          >
            <span v-show="isSubmit">
              <i class="fas fa-spinner fa-spin"></i> </span
            >Apply
          </button>
        </div>
      </div>
    </Modal>
    <Modal @close="rePrintModal()" :modalActive="rePrintModalActive">
      <div class="modal-content scrollbar-width-thin">
        <div class="modal-header">
          <h5>Reprint Invoice</h5>
          <button @click="rePrintModal()" type="button" class="btn btn-default">
            X
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-12">
              <div class="mb-3">
                <label for="customer_group_id" class="form-label"
                  >Invoice Number *</label
                >
                <input
                  type="text"
                  class="form-control border"
                  v-model="invoice_number"
                  placeholder="Invoice Number"
                  autocomplete="off"
                />
                <div class="invalid-feedback" v-if="popupError != ''">
                  {{ popupError }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary" @click="findInvoice">
            <span v-show="invDisabled" :disabled="disabled">
              <i class="fas fa-spinner fa-spin"></i>
            </span>
            Submit
          </button>
        </div>
      </div>
    </Modal>

    <!-- Only Return -->
    <Modal @close="returnReplaceModal()" :modalActive="returnReplaceModalActive">
      <div class="modal-content scrollbar-width-thin">
        <div class="modal-header">
          <h5>Return</h5>
          <button
            @click="returnReplaceModal()"
            type="button"
            class="btn btn-default"
          >
            X
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-12">
              <div class="mb-3">
                <label for="customer_group_id" class="form-label"
                  >Invoice Number *</label
                >
                <input
                  type="text"
                  class="form-control border"
                  v-model="invoice_number"
                  placeholder="Invoice Number"
                  autocomplete="off"
                />
                <div class="invalid-feedback" v-if="popupError != ''">
                  {{ popupError }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary" @click="findInvoice('return')">
            <span v-show="invDisabled" :disabled="disabled">
              <i class="fas fa-spinner fa-spin"></i>
            </span>
            Submit
          </button>
        </div>
      </div>
    </Modal>

    <Modal @close="returnReplacePageModal()" :modalActive="returnReplacePageModalActive">
      <div class="modal-content scrollbar-width-thin return-replace-modal">
        <div class="modal-header">
          <h5>Return & Replace</h5>
          <button
            @click="returnReplacePageModal()"
            type="button"
            class="btn btn-default"
          >
            X
          </button>
        </div>
        <div class="modal-body" id="printMe">
          <div v-if="returnInfo">
            <div id="mid">
              <div class="info">
                <p class="text-left" style="font-size: 14px">
                  Name: {{ returnInfo.customer_name }}<br />
                  Address: {{ returnInfo.customer.address }} <br />
                  Mobile: {{ returnInfo.customer.phone }}<br />
                  Srvd by: {{ returnInfo.created_by.name }}
                </p>
              </div>
            </div>
            <!--End Invoice Mid-->
            <div id="bot">
              <div id="table">
                <table>
                  <tr class="borderTop borderBottom">
                    <td class="hours">Sl</td>
                    <td class="item" style="width: 20%"><h2>Item Name</h2></td>
                    <td class="hours text-center"><h2>Qty</h2></td>
                    <td class="hours text-center"><h2>R.Qty</h2></td>
                    <td class="rate text-center"><h2>MRP</h2></td>
                    <td class="rate text-center"><h2>R. Disc. (%)</h2></td>
                    <td class="rate text-center"><h2>Disc Val</h2></td>
                    <td class="subtotal text-center"><h2>Amount</h2></td>
                    <td class="action text-center"><h2>Action</h2></td>
                  </tr>
                  <tr
                    class="borderBottom"
                    v-for="(item, i) in returnInfo.sales_items"
                    v-if="returnInfo.sales_items.length > 0"
                    :key="item.id"
                  >
                    <td class="">
                      <p class="">{{ i + 1 }}</p>
                    </td>
                    <td class="">
                      {{ item.products.product_name }}
                      <!-- {{$store.getters.productItems}} -->
                      <!-- <Multiselect v-if="return_replace.length > 0 && return_replace[i].return_or_replace == 1"
                            class="form-control border customer_id" 
                            mode="single"
                            v-model="return_replace[i].replace_pro_id"
                            placeholder="Select product"   
                            :searchable="true" 
                            :filter-results="true"
                            :options="state.products"
                            :classes="multiclasses"
                            :close-on-select="true" 
                            :min-chars="1"
                            :resolve-on-load="false"
                          />   -->
                    </td>
                    <td class="text-center">
                      {{ item.quantity }}
                    </td>
                    <td class="text-center">
                      <!-- <input v-if="return_replace.length > 0 && return_replace[i].return_or_replace == '0'" type="number" class="qty form-control" v-model="return_replace[i].return_qty">  -->
                      
                        <!-- v-if="
                          return_replace.length > 0 &&
                          (return_replace[i].return_or_replace == '0' ||
                            return_replace[i].return_or_replace == '1')
                        " -->
                      
                      <input
                        :readonly="(return_replace.length > 0 &&
                          (return_replace[i].return_or_replace == '0' ||
                            return_replace[i].return_or_replace == '1')) ? false : true"
                        type="number"
                        class="qty form-control"
                        min="1"
                        @keyup="checkReturnQuantity($event.target.value, i, item.quantity)"
                        @change="checkReturnQuantity($event.target.value, i, item.quantity)"
                        v-model="return_replace[i].return_qty"
                      />
                    </td>
                    <td class="text-center">
                      <p class="">{{ item.mrp_price }}</p>
                    </td>
                    <td class="text-center">
                      <input
                        :readonly="(return_replace.length > 0 &&
                          (return_replace[i].return_or_replace == '0' ||
                            return_replace[i].return_or_replace == '1')) ? false : true"
                        type="number"
                        class="form-control"
                        v-model="return_replace[i].return_discount_percent"
                        @input="returnDiscountApply($event.target.value, i, item)"
                        min="0"
                        max="100"
                        step="any"
                        style="width: 100px; text-align: center;"
                      />
                    </td>
                  
                    <td class="text-end">
                      <p class="">{{ (item.discount * item.quantity).toFixed(2) }}</p>
                    </td>

                    <td class="text-end">
                      <p class="">{{ (item.quantity * item.mrp_price) - (item.discount * item.quantity) }}</p>
                    </td>
                    <td class="action text-center" v-if="return_replace.length > 0">
                      <label style="float: none;"
                        ><input
                          type="radio"
                          v-model="return_replace[i].return_or_replace"
                          value="1"
                          @change="itemReturnOrReplace($event.target.value, i)"
                        />Return</label
                      >
                      <!-- <label><input type="radio" v-model="return_replace[i].return_or_replace" value="1" @change="itemReturnOrReplace($event.target.value, i)">Replace</label>  -->
                    </td>
                  </tr>

                  <tr
                    class="return-replace-summary"
                    v-if="returnInfo.total_amount"
                  >
                    <td colspan="6"></td>
                    <td class="Rate" colspan="2"><h2>Total Amount</h2></td>
                    <td class="payment">
                      <h2>{{ returnInfo.total_amount }}</h2>
                    </td>
                  </tr>
                  <tr
                    class="return-replace-summary"
                  >
                    <td colspan="6"></td>
                    <td class="Rate" colspan="2"><h2>Discount</h2></td>
                    <td class="payment">
                      <h2>{{ Number(parseFloat(returnInfo.sales_items_sum_discount) + parseFloat(returnInfo.customer_discount)+ parseFloat(returnInfo.customer_group_discount)+ parseFloat(returnInfo.order_discount) ).toFixed(2)  }}</h2>
                    </td>
                  </tr>
                  <!-- <tr
                    class="return-replace-summary"
                    v-if="returnInfo.order_discount"
                  >
                    <td colspan="4"></td>
                    <td class="Rate" colspan="2"><h2>Special Discount</h2></td>
                    <td class="payment">
                      <h2>{{ returnInfo.order_discount }}</h2>
                    </td>
                  </tr> -->
                  <tr
                    class="return-replace-summary"
                    v-if="returnInfo.order_vat || returnInfo.order_items_vat"
                  >
                    <td colspan="6"></td>
                    <td class="Rate" colspan="2"><h2>VAT</h2></td>
                    <td class="payment">
                      <h2>
                        {{ returnInfo.order_vat + returnInfo.order_items_vat }}
                      </h2>
                    </td>
                  </tr>
                  <tr
                    class="return-replace-summary"
                    v-if="returnInfo.grand_total"
                  >
                    <td colspan="6"></td>
                    <td class="Rate" colspan="2"><p>Net Amount</p></td>
                    <td class="payment">
                      <p>{{ returnInfo.grand_total }}</p>
                    </td>
                  </tr>
                  <tr
                    class="return-replace-summary"
                    v-if="returnInfo.paid_amount"
                  >
                    <td colspan="6"></td>
                    <td class="Rate" colspan="2"><p>Paid Amount</p></td>
                    <td class="payment">
                      <p>{{ returnInfo.paid_amount }}</p>
                    </td>
                  </tr>
                  <tr class="return-replace-summary">
                    <td colspan="6"></td>
                    <td class="Rate" colspan="2"><p>Return Amount</p></td>
                    <td class="payment">
                      {{ salesReturnAmountSumVal }}
                      <input
                        type="hidden"
                        v-model="sale_return_info.return_amount"
                        style="width: 100%"
                      />
                    </td>
                  </tr>
                  <tr class="return-replace-summary">
                    <td colspan="6"></td>
                    <td class="Rate" colspan="2">
                      <h2>Reason of return (Optional):</h2>
                    </td>
                    <td class="payment">
                      <textarea rows="1" v-model="sale_return_info.return_reason"></textarea>
                    </td>
                    <!-- <td colspan="2"></td>
                    <td class="Rate" colspan="2">
                      <h2>Reason of return (Optional):</h2>
                    </td>
                    <td class="payment">
                      <input
                        type="text"
                        v-model="sale_return_info.return_reason"
                      />
                    </td> -->
                  </tr>
                  <!-- <tr class="return-replace-summary">
                    <td colspan="5"></td>
                    <td class="Rate" colspan="2">
                      <h2>Cost Center dfsdf:</h2>
                    </td>
                    <td class="payment">
                      <treeselect 
                        v-model="sale_return_info.cost_center_id"
                        :multiple="false" 
                        :always-open="false"
                        :options="costCenterOptions"
                        :value-consists-of="valueConsistsOf"
                        :normalizer="normalizer"
                        :default-expand-level="Infinity"
                        :disable-branch-nodes="true"
                        :search-nested="true"                                                
                        placeholder='Select Cost Center'
                        v-if="renderOptionComponent"
                    />
                    </td>
                  </tr> -->
                </table>
              </div>
              <!--End Table-->
            </div>
            <!--End InvoiceBot-->
          </div>
          <!--End Invoice-->
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-return" @click="voidInvoice">
            <span v-show="invDisabled" :disabled="disabled">
              <i class="fas fa-spinner fa-spin"></i> </span
            >Void Invoice
          </button>
          <button
            type="submit"
            class="btn btn-return"
            @click="returnAndReplace"
          >
            <span v-show="invDisabled" :disabled="disabled">
              <i class="fas fa-spinner fa-spin"></i>
            </span>
            Return
          </button>
        </div>
      </div>
    </Modal>

    <!-- Only Replace -->
    <Modal @close="saleReplaceModal()" :modalActive="saleReplaceModalActive">
      <div class="modal-content scrollbar-width-thin">
        <div class="modal-header">
          <h5>Replace</h5>
          <button
            @click="saleReplaceModal()"
            type="button"
            class="btn btn-default"
          >
            X
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-12">
              <div class="mb-3">
                <label for="customer_group_id" class="form-label"
                  >Invoice Number *</label
                >
                <input
                  type="text"
                  class="form-control border"
                  v-model="invoice_number"
                  placeholder="Invoice Number"
                  autocomplete="off"
                />
                <div class="invalid-feedback" v-if="popupError != ''">
                  {{ popupError }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary" @click="findInvoice">
            <span v-show="invDisabled" :disabled="disabled">
              <i class="fas fa-spinner fa-spin"></i>
            </span>
            Submit
          </button>
        </div>
      </div>
    </Modal>

    <Modal @close="saleReplacePageModal()" :modalActive="saleReplacePageModalActive">
      <div class="modal-content scrollbar-width-thin return-replace-modal">
        <div class="modal-header">
          <h5>Replace</h5>
          <button
            @click="saleReplacePageModal()"
            type="button"
            class="btn btn-default"
          >
            X
          </button>
        </div>
        <div class="modal-body" id="printMe">
          <div v-if="returnInfo">
            <div id="mid">
              <div class="info">
                <p class="text-left" style="font-size: 14px">
                  Name: {{ returnInfo.customer.name }}<br />
                  Address: {{ returnInfo.customer.address }} <br />
                  Mobile: {{ returnInfo.customer.phone }}<br />
                  Srvd by: {{ returnInfo.created_by.name }}
                </p>
              </div>
            </div>
            <!--End Invoice Mid-->
            <div id="bot">
              <div id="table">
                <table>
                  <tr class="borderTop borderBottom">
                    <td class="hours">Sl</td>
                    <td class="item"><h2>Item Name</h2></td>
                    <td class="hours"><h2>Qty</h2></td>
                    <td class="hours"><h2>R.Qty</h2></td>
                    <td class="rate"><h2>MRP</h2></td>
                    <td class="subtotal"><h2>Amount</h2></td>
                    <td class="action"><h2>Action</h2></td>
                  </tr>
                  <tr
                    class="borderBottom"
                    v-for="(item, i) in returnInfo.sales_items"
                    v-if="returnInfo.sales_items.length > 0"
                    :key="item.id"
                  >
                    <td class="">
                      <p class="">{{ i + 1 }}</p>
                    </td>
                    <td class="">
                      {{ item.products.product_name }}
                      <!-- {{$store.getters.productItems}} -->
                      <Multiselect
                        v-if="
                          return_replace.length > 0 &&
                          return_replace[i].return_or_replace == 1
                        "
                        class="form-control border customer_id"
                        mode="single"
                        v-model="return_replace[i].replace_pro_id"
                        placeholder="Select product"
                        :searchable="true"
                        :filter-results="true"
                        :options="state.products"
                        :classes="multiclasses"
                        :close-on-select="true"
                        :min-chars="1"
                        :resolve-on-load="false"
                        @change="onChangeReplaceProduct($event, i)"
                      />
                    </td>
                    <td class="">{{ item.quantity }}</td>
                    <td class="">
                      <!-- <input v-if="return_replace.length > 0 && return_replace[i].return_or_replace == '0'" type="number" class="qty form-control" v-model="return_replace[i].return_qty">  -->
                      <input
                        v-if="
                          return_replace.length > 0 &&
                          (return_replace[i].return_or_replace == '0' ||
                            return_replace[i].return_or_replace == '1')
                        "
                        type="number"
                        class="qty form-control"
                        v-model="return_replace[i].return_qty"
                      />
                    </td>
                    <td class="">
                      <p class="">{{ item.mrp_price }}</p>
                      <p
                        v-if="
                          return_replace.length > 0 &&
                          return_replace[i].replace_pro_id != ''
                        "
                        class=""
                      >
                        {{ return_replace[i].replace_mrp_price }}
                      </p>
                    </td>
                    <td class="">
                      <p class="">{{ item.quantity * item.mrp_price }}</p>
                      <p
                        v-if="
                          return_replace.length > 0 &&
                          return_replace[i].replace_pro_id != ''
                        "
                        class=""
                      >
                        {{
                          return_replace[i].return_qty *
                          return_replace[i].replace_mrp_price
                        }}
                      </p>
                    </td>
                    <td class="action" v-if="return_replace.length > 0">
                      <!-- <label><input type="radio" v-model="return_replace[i].return_or_replace" value="0" @change="itemReturnOrReplace($event.target.value, i)">Return</label> -->
                      <label
                        ><input
                          type="radio"
                          v-model="return_replace[i].return_or_replace"
                          value="1"
                          @change="itemReturnOrReplace($event.target.value, i)"
                        />Replace</label
                      >
                    </td>
                  </tr>

                  <tr
                    class="return-replace-summary"
                    v-if="returnInfo.total_amount"
                  >
                    <td colspan="4"></td>
                    <td class="Rate" colspan="2"><h2>Total Amount</h2></td>
                    <td class="payment">
                      <h2>{{ returnInfo.total_amount }}</h2>
                    </td>
                  </tr>
                  <tr
                    class="return-replace-summary"
                    v-if="returnInfo.customer_group_discount"
                  >
                    <td colspan="4"></td>
                    <td class="Rate" colspan="2"><h2>Discount</h2></td>
                    <td class="payment">
                      <h2>{{ returnInfo.customer_group_discount }}</h2>
                    </td>
                  </tr>
                  <!-- <tr
                    class="return-replace-summary"
                    v-if="returnInfo.order_discount"
                  >
                    <td colspan="4"></td>
                    <td class="Rate" colspan="2"><h2>Special Discount</h2></td>
                    <td class="payment">
                      <h2>{{ returnInfo.order_discount }}</h2>
                    </td>
                  </tr> -->
                  <tr
                    class="return-replace-summary"
                    v-if="returnInfo.order_vat || returnInfo.order_items_vat"
                  >
                    <td colspan="4"></td>
                    <td class="Rate" colspan="2"><h2>VAT</h2></td>
                    <td class="payment">
                      <h2>
                        {{ returnInfo.order_vat + returnInfo.order_items_vat }}
                      </h2>
                    </td>
                  </tr>
                  <tr
                    class="return-replace-summary"
                    v-if="returnInfo.grand_total"
                  >
                    <td colspan="4"></td>
                    <td class="Rate" colspan="2"><h2>Net Amount</h2></td>
                    <td class="payment">
                      <h2>{{ returnInfo.grand_total }}</h2>
                    </td>
                  </tr>
                  <tr
                    class="return-replace-summary"
                    v-if="returnInfo.paid_amount"
                  >
                    <td colspan="4"></td>
                    <td class="Rate" colspan="2"><h2>Paid Amount</h2></td>
                    <td class="payment">
                      <h2>{{ returnInfo.paid_amount }}</h2>
                    </td>
                  </tr>
                  <!-- <tr class="return-replace-summary"> 
                        <td colspan="4"></td>
                        <td class="Rate" colspan="2"><h2>Return Amount</h2></td>
                        <td class="payment"><input type="number" v-model="sale_return_info.return_amount" ></td>
                      </tr> -->
                  <tr class="return-replace-summary">
                    <td colspan="4"></td>
                    <td class="Rate" colspan="2">
                      <h2>Reason of return (Optional):</h2>
                    </td>
                    <td class="payment">
                      <input
                        type="text"
                        v-model="sale_return_info.return_reason"
                      />
                    </td>
                  </tr>
                </table>
              </div>
              <!--End Table-->
            </div>
            <!--End InvoiceBot-->
          </div>
          <!--End Invoice-->
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-return" @click="saleReplace">
            <span v-show="invDisabled" :disabled="disabled">
              <i class="fas fa-spinner fa-spin"></i>
            </span>
            Submit
          </button>
        </div>
      </div>
    </Modal>

    <Modal @close="addConfirmModal()" :modalActive="confirmModalActive">
      <div class="modal-content scrollbar-width-thin confirm-window">
        <div class="modal-header">
          <h5>Invoice Preview</h5>
          <button
            @click="addConfirmModal()"
            type="button"
            class="btn btn-default"
          >
            X
          </button>
        </div>
        <div class="modal-body inv-perview" v-if="presCartItems.length > 0">
          <div id="invoice-perview">
            <div id="top">
              <div class="row">
                <h2 class="text-center" style="font-size: 18px">{{this.retailShopName}}</h2>
                <h5 class="text-center" style="font-size: 14px"> {{ this.retailSmallText }}</h5>
                <p class="text-center cmb-5">
                  {{ this.retailShopAddress }}
                  <span v-if="invHeadPhone">  <br>  Mobile: {{ this.invHeadPhone }} </span>
                </p>
                  <h2 class="text-center ">INVOICE</h2>
                
              </div>
            </div>
            <!--End InvoiceTop-->
            <div id="mid">
              <div class="info">
                <p class="text-left" style="font-size: 14px">
                  Customer: {{ customer.label }}<br />
                  Address: {{ customer.address }} <br />
                  Mobile: {{ customer.phone }}<br />
                  Srvd by: {{ $store.getters.userData.user.name }}<br />
                  Sales Point: {{ $store.getters.userData.user.outlet_name }}
                </p>
              </div>
            </div>
            <!--End Invoice Mid-->
            <div id="bot">
              <div id="table">
                <table >
                  <tr class="borderTop borderBottom">
                    <td class="item"><h2>Item Name</h2></td> 
                    <td class="hours"><h2>Qty</h2></td>
                    <td class="hours"><h2>WT</h2></td>
                    <td class="rate text-center"><h2>Rate</h2></td> 
                    <td class="rate text-center"><h2>Value</h2></td> 
                    <td class="rate text-center"><h2>Disc</h2></td>
                    <td class="subtotal text-right"><h2>Amount</h2></td>  
                  </tr>

                  <tr
                    class="service "
                    v-for="(item, i) in presCartItems"
                    v-if="presCartItems.length > 0"
                    :key="i"
                  >
                  <td class="item"><h2>{{ item.product_name }}</h2></td>
                    <td class="hours"><h2>{{ item.quantity }}</h2></td>
                    <td class="hours"><h2>{{ item.weight }}</h2></td> 
                    <td class="rate text-center"><h2 >{{ Number(item.mrp_price).toFixed(0) }}</h2></td>
                    <td class="rate text-center"><h2 >{{
                          item.uom == 5
                            ? parseFloat(
                                item.mrp_price * item.weight  
                              ).toFixed(2)
                            : parseFloat(
                                item.mrp_price * item.quantity 
                              ).toFixed(2)
                        }}</h2></td>
                    <td class="rate text-right">
                        <h2 class="text-right">{{
                          item.uom == 5
                            ? parseFloat(
                                 (item.discount * item.weight)
                              ).toFixed(2)
                            : parseFloat(
                                (item.discount *  item.quantity)
                              ).toFixed(2)
                        }} </h2></td>
                    <td class="subtotal"><h2 class="text-right">{{
                          item.uom == 5
                            ? parseFloat(
                                item.mrp_price * item.weight - (item.discount * item.weight)
                              ).toFixed(2)
                            : parseFloat(
                                item.mrp_price * item.quantity - (item.discount *  item.quantity)
                              ).toFixed(2)
                        }}</h2></td>
 
                  </tr>
                  <tr class="service " >   
                    <td class="text-right">Total &nbsp</td> 
                    <td class=""><h2>{{parseFloat(totalItemQty).toFixed(0)}} </h2> </td>
                    <td class=""><h2>{{parseFloat(totalItemWeight).toFixed(3)}} </h2></td>  
                    <td class="text-center"> </td>   
                    <td class="text-center"><h2>{{parseFloat(totalItemValue).toFixed(0)}}</h2> </td>   
                    <!-- <td class="text-right"><h2>{{parseFloat(totalItemDiscountValue).toFixed(0)}} </h2></td> -->
                    <td class="text-right"><h2>{{parseFloat(totalItemDiscountValue).toFixed(2)}} </h2></td>
                    <td class="text-right"><h2>{{parseFloat(totalItemNetValue).toFixed(2)}} </h2></td> 
                  </tr>
                  <tr v-if="totalCartValue" class="service">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="Rate" colspan="2"><h2>Total Amount</h2></td>
                    <td class="payment">
                      <h2 class="text-right">{{ Number(totalCartValue).toFixed(2) }}</h2>
                    </td>
                  </tr>
                  <tr class="service">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="Rate" colspan="2"><h2>Discount</h2></td>
                    <td class="payment ">
                      <h2 class="text-right">
                        {{
                          Number(
                            Number(
                      customer_discount + customer_group_discount
                    ) + special_discount + couponDiscoun + all_discount
                          ).toFixed(2)
                        }}
                      </h2>
                    </td>
                  </tr> 
                  <tr v-if="totalCartTax" class="service">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="Rate" colspan="2"><h2>VAT</h2></td>
                    <td class="payment">
                      <h2 class="text-right">{{ totalCartTax.toFixed(2) }}</h2>
                    </td>
                  </tr>
                  <tr v-if="netAmountCalculate">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="Rate" colspan="2"><h2>Net Amount</h2></td>
                    <td class="payment">
                      <h2 class="text-right">{{ Number(netAmountCalculate).toFixed(2) }}</h2>
                    </td>
                  </tr>
                </table>
              </div>
              <!--End Table-->

              <div id=" ">
                <h2 class="service borderBottom">Payment Description:</h2>
                <table>
                  <tr class="service borderBottom">
                    <td>Description</td>
                    <td class="text-right">Amount</td>
                  </tr>
                  <tr
                    class="service borderBottom"
                    v-for="(item, i) in pform.payments"
                    :key="item.id"
                  >
                    <td>
                      {{
                        item.paid_by.charAt(0).toUpperCase() +
                        item.paid_by.slice(1)
                      }}
                    </td>
                    <td class="text-right">{{ Number(item.amount).toFixed(2) }}</td>
                  </tr>
                  <tr class="service borderBottom" v-if="(netAmountCalculate - totalCollections) > 0">
                    <td>
                      Due
                    </td>
                    <td class="text-right">{{ Number(netAmountCalculate - totalCollections).toFixed(2) }}</td>
                  </tr>
                  <tr class="service borderBottom" v-else>
                    <td>
                      Return
                    </td>
                    <td class="text-right">{{ Math.abs(Number(netAmountCalculate - totalCollections)).toFixed(2) }}</td>
                  </tr>
                </table>
              </div>
              <!-- <div id="legalcopy">
                <h2 class="text-center borderBottom">Note:</h2>
                <p>Please Exchange Any Product Within 72 Hours</p>
              </div> -->
            </div>
            <!--End InvoiceBot-->
          </div>
          <!--End Invoice-->
        </div>
        <div class="modal-footer">
          <div class="col-md-12">
            <div class="row button-list pt-2">
              <div class="col-md-4" style="padding: 0">
                <div class="d-grid">
                  <button type="button" class="btn btn-sm btn-primary" @click="handleSaleHoldSubmit" >
                    Save
                  </button>
                </div>
              </div>
              <div class="col-md-4" style="padding: 0 5px">
                <div class="d-grid">
                  <button
                    type="button"
                    class="btn btn-sm btn-info"
                    @click="addConfirmModal()"
                  >
                    Add New Item
                  </button>
                </div>
              </div>
              <div class="col-md-4" style="padding: 0 5px">
                <div class="d-grid">
                  <button
                    type="button"
                    class="btn btn-sm btn-success"
                    @click="handleSubmit"
                    :disabled="btn_disabled"
                  >
                    <span v-show="isSubmit">
                      <i class="fas fa-spinner fa-spin"></i>
                    </span>
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>

    <Modal @close="invoiceModal()" :modalActive="invoiceModalActive">
      <div class="modal-content scrollbar-width-thin invoice-modal">
        <div class="modal-header">
          <h5>Invoice</h5>
          <button @click="invoiceModal()" type="button" class="btn btn-default">
            X
          </button>
        </div>
        <div class="modal-body inv-perview" id="printMe">
          <div id="invoice-POS" v-if="invoice_info">
            <div id="top">
              <div class="row">
                <h2 class="text-center" style="font-size: 18px">{{this.retailShopName}}</h2>
                <h5 class="text-center" style="font-size: 14px"> {{ this.retailSmallText }}</h5>
                <p class="text-center cmb-5">
                  {{ this.retailShopAddress }}
                 <span v-if="invHeadPhone"> <br> Mobile: {{ this.invHeadPhone }} </span>
                </p> 
                <p class="text-center" ><strong> INVOICE </strong></p> 
              </div>
            </div>
            <!--End InvoiceTop-->
            <div id="mid" class="fnt10">
              <div class="info">
                <p class="text-left" style="font-size: 14px">
                  Patient : {{ invoice_info.customer_name }}<br />
                  Address: {{ invoice_info.customer.address }} <br />
                  Mobile: {{ invoice_info.customer.phone }}<br />
                  Srvd by: {{ invoice_info.created_by.name }} <br>  
                </p> 
              </div>
              <table  id="table" style="width: 100% !important;">
                <tr class="service borderBottom">
                  <td> #{{ invoice_info.invoice_number }}</td>
                  <td class="text-right" style="text-align: right" >{{ invoice_info.created_at }}</td>
                </tr> 
              </table>

            </div>
            <!--End Invoice Mid-->
            <div id="bot" class="fnt10">
              <div id="table">
                <table  style="width: 100% !important;">
                  <tr class="  borderBottom borderTop">
                    <td class="item">Item Name</td>
                    <td class="hours">Qty</td>
                    <td class="hours">Wt</td>
                    <td class="rate text-center">MRP</td>
                    <td class="rate text-center">Value</td>
                    <td class="subtotal text-center">Amount</td>
                  </tr>

                  <tr
                    class="  borderBottom"
                    v-for="(item, i) in invoice_info.sales_items"
                    v-if="invoice_info.sales_items.length > 0"
                    :key="i"
                  >
                    <td class="item">{{ item.products.product_name }}</td>
                     
                    <td class="tableitem"> {{ item.quantity }} 
                    </td>
                    <td class="tableitem"> {{ item.weight }} 
                    </td>
                    <td class="tableitem" style="text-align: right"> {{ Number(item.mrp_price).toFixed(2) }} 
                    </td>
                    <td class="rate text-center"> {{
                          item.uom == 5
                            ? parseFloat(
                                item.mrp_price * item.weight  
                              ).toFixed(2)
                            : parseFloat(
                                item.mrp_price * item.quantity 
                              ).toFixed(2)
                        }} </td>
                    <td class="tableitem text-right" style="text-align: right"> 
                        {{
                          item.uom == 5
                            ? parseFloat(
                                item.mrp_price * item.weight - (item.discount*item.weight)
                              ).toFixed(2)
                            : parseFloat(
                                item.mrp_price * item.quantity - (item.discount*item.quantity)
                              ).toFixed(2)
                        }} 
                    </td>
                  </tr>
                  <tr class=" " v-if="invoice_info.total_amount">
                    <td></td>
                    <td></td> 
                    <td class="Rate" colspan="3"> Total Amount </td>
                    <td class="payment text-right" style="text-align: right" > {{ Number(invoice_info.total_amount).toFixed(2) }} 
                    </td>
                  </tr> 
                  <tr class=" " v-if="invoice_info.customer_group_discount" >
                    <td></td>
                    <td></td> 
                    <td class="Rate" colspan="3"> Customer Discount </td>
                    <td class="payment text-right" style="text-align: right" > {{ Number(invoice_info.customer_group_discount).toFixed(2) }} 
                    </td>
                  </tr>
                  <tr class=" " v-if="invoice_info.order_discount || invoice_info.sales_items_sum_discount">
                    <td></td>
                    <td></td>
                    <td class="Rate" colspan="3">Discount</td>
                    <td class="payment text-right" style="text-align: right"> {{ Number(invoice_info.order_discount_value + invoice_info.sales_items_sum_discount).toFixed(2) }} </td>
                  </tr>
                  <tr
                    class=" "  v-if="invoice_info.order_vat || invoice_info.order_items_vat">
                    <td></td>
                    <td></td> 
                    <td  colspan="3"> VAT </td>
                    <td class="text-right" style="text-align: right"> {{
                          Number(invoice_info.order_vat + invoice_info.order_items_vat).toFixed(2)
                        }} 
                    </td>
                  </tr>
                  <tr class=" " v-if="invoice_info.grand_total">
                    <td></td>
                    <td></td> 
                    <td class="Rate" colspan="3">Net Amount</td>
                    <td class="payment text-right" style="text-align: right"> {{ Number(invoice_info.grand_total).toFixed(2) }} </td>
                  </tr>
                  <tr class=" " v-if="invoice_info.paid_amount">
                    <td></td>
                    <td></td> 
                    <td class="Rate" colspan="3">Paid Amount</td>
                    <td class="payment text-right" style="text-align: right"> <string> {{ Number(invoice_info.paid_amount).toFixed(2) }} </string></td>
                  </tr>
                </table>
              </div>
              <!--End Table-->

              <div class="col-md-12"  >
                <p style="margin-bottom: 0px; margin-top:5px"> <strong>Payment Description :</strong> </p>
                <table  id="table" style="width: 100% !important;">
                  <tr class="service borderBottom">
                    <td>Description</td>
                    <td class="text-right" style="text-align: right" >Amount</td>
                  </tr>
                  <tr
                    class="service borderBottom"
                    v-for="(item, i) in invoice_info.payments"
                    v-if="invoice_info.payments.length > 0"
                    :key="item.id"
                  >
                    <td>{{ item.paying_by }}</td>
                    <td class="text-right" style="text-align: right">{{ Number(item.amount).toFixed(2) }}</td>
                  </tr>
                </table>
              </div>
              
              <div id="legalcopy">
                <h5 class="text-left">In words: <span class="amount-in-word">{{  invoice_info ? inWords(invoice_info.grand_total) : inWords(0) }}</span> </h5>
              </div>

              <div id="legalcopy" class="text-center">
                <BarcodeGenerator
                  :value="invoice_info.invoice_number"
                  :format="'CODE128'"
                  :lineColor="'black'"
                  :height="30"
                  :width="1"
                  :elementTag="'img'"
                  :textPosition="19"
                  :fontSize="15"
                  :text="invoice_info.invoice_number"
                /> 
              </div>
              <div id="legalcopy">
                <h2 class="text-center borderBottom">Note:</h2>
                <p>Please Exchange Any Product Within 24 Hours</p>
              </div>

              <div id="legalcopy">
                <p class="borderTop"><strong>System By: </strong>SSG-IT</p>
              </div>
            </div>
            <!--End InvoiceBot-->
          </div>
          <!--End Invoice-->
        </div>
        <div class="modal-footer">
          <div class="col-md-12">
            <div class="row button-list pt-2">
              <div class="col-md-4" style="padding: 0 5px">
                <div class="d-grid">
                  <button
                    type="button"
                    class="btn btn-sm btn-success"
                    @click="print('invoice-POS')"
                  >
                    Print
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>

    <Modal @close="barcodeReaderModal()" :modalActive="barcodeReaderModalActive">
      <div class="modal-content scrollbar-width-thin barcodeReaderModal">
        <div class="modal-header">
          <h5>Barcode Reader</h5>
          <button
            @click="barcodeReaderModal()"
            type="button"
            class="btn btn-default"
          >
            X
          </button>
        </div>

        <div class="modal-footer">
          <div class="col-md-12">
            <div class="row button-list pt-2">
              <div class="col-md-4" style="padding: 0 5px">
                <div class="d-grid">
                  <button
                    type="button"
                    class="btn btn-sm btn-danger"
                    @click="barcodeReaderModal()"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>

  </div>
</template>
<script setup>
  import { ref, reactive, computed, watch, inject, onMounted, nextTick, onBeforeUnmount, onUpdated, onBeforeUpdate, getCurrentInstance } from "vue";
  import Form from "vform";
  import axios from "axios";
  import { useStore } from "vuex";
  import { useToast } from "vue-toastification";
  import Modal from "./../helper/Modal";
  import BarcodeGenerator from "@/components/BarcodeGenerator.vue";
  import { useRoute, useRouter } from "vue-router";

  // name: "PosLeftbar",
  const store = useStore();
  const toast = useToast();
  const router = useRouter();
  const route = useRoute();
  const swal = inject("$swal");
  const app = getCurrentInstance();
  const app2 = app.appContext.config.globalProperties;

  console.log("app2", app2.apiUrl);

  const queryAppointmentId = route.query.appointment_id ?? null;
  const queryType = route.query.type ?? null;
  const querySearchCode = ref("");

  const count = ref(0);
  const state = reactive({
    companies: [],
    customer_groups: [],
    areas: [],
    units: [],
    districts: [],
    customers: [],
    customers_info: [],
    wallets: [],
    points_setting: "",
    banks: [],
    products: [],
  });

  let disabled = ref("");
  let disabledCBtn = ref("");
  const paymentModalActive = ref(false);
  const customerModalActive = ref(false);
  const discountModalActive = ref(false);
  const confirmModalActive = ref(false);
  const rePrintModalActive = ref(false);
  const returnReplaceModalActive = ref(false);
  const returnReplacePageModalActive = ref(false);
  const saleReplaceModalActive = ref(false);
  const saleReplacePageModalActive = ref(false);
  const modalActive = ref(false);
  const taxModalActive = ref(false);
  const invoiceModalActive = ref(false);
  const barcodeReaderModalActive = ref(false);

  const paymentModal = () => {
    paymentModalActive.value = !paymentModalActive.value;
  };
  const taxModal = () => {
    taxModalActive.value = !taxModalActive.value;
  };
  const customerModal = () => {
    customerModalActive.value = !customerModalActive.value;
  };
  const addDiscountModal = () => {
    discountModalActive.value = !discountModalActive.value;
  };
  const addConfirmModal = () => {
    confirmModalActive.value = !confirmModalActive.value;
  };
  const rePrintModal = () => {
    rePrintModalActive.value = !rePrintModalActive.value;
  };
  const returnReplaceModal = () => {
    returnReplaceModalActive.value = !returnReplaceModalActive.value;
  };
  const returnReplacePageModal = () => {
    returnReplacePageModalActive.value = !returnReplacePageModalActive.value;
  };

  const saleReplaceModal = () => {
    saleReplaceModalActive.value = !saleReplaceModalActive.value;
  };
  const saleReplacePageModal = () => {
    saleReplacePageModalActive.value = !saleReplacePageModalActive.value;
  };

  const invoiceModal = () => {
    invoiceModalActive.value = !invoiceModalActive.value;
  };

  const barcodeReaderModal = () => {
    barcodeReaderModalActive.value = !barcodeReaderModalActive.value;
  };

  const customer_id = computed(() => {
    //return (store.getters.presCartInfo.length > 0 ) ? JSON.parse(JSON.stringify(store.getters.presCartInfo))[0].customer_id : '';
  });
  const orderedDiscount = computed(() => {
    //return (store.getters.presCartInfo.length > 0 ) ? JSON.parse(JSON.stringify(store.getters.presCartInfo))[0].order_discount : 0;
  });
  const orderedTax = computed(() => {
    //return (store.getters.presCartInfo.length > 0 ) ? JSON.parse(JSON.stringify(store.getters.presCartInfo))[0].order_tax : 0;
  });

  const totalCartValue = computed(() => {
    return store.getters.presCartItems.reduce(function (total, item) {
      if (item.uom == 5) {
        return total + item.mrp_price * item.weight;
      } else {
        return total + item.mrp_price * item.quantity;
      }
    }, 0);
  });

  const cartItemDiscount = computed(() => {
    return store.getters.presCartItems.reduce(function (total, item) {
      return total + item.item_discount * item.quantity;
    }, 0);
  });

  const totalCartTax = computed(() => {
    return store.getters.presCartItems.reduce(function (total, item) {
      return total + item.tax * item.quantity;
    }, 0);
  });

  const pointToAmount = computed(() => {
    //return state.points_setting.cart_price_rate / state.points_setting.cart_points_rate * this.customer.points
    return 100;
  });

  const convartRate = computed(() => {
    return (
      state.points_setting.cart_price_rate /
      state.points_setting.cart_points_rate
    );

    console.log('points_setting', state.points_setting)
    //return 100
  });

  const all_discount = computed(() => {
    return store.getters.presCartItems.reduce(function (total, item) {
      return total + item.discount * item.quantity;
    }, 0);
  });

  const clearAllCartItems = () => {
    swal({
      title: "Are you sure?",
      text: "You want clear cart list!",
      showCancelButton: true,
      confirmButtonCategory: "#3085d6",
      cancelButtonCategory: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.value) {
        store.dispatch("removePresSaleAllCartItems");
        // toast("Cart list cleared!");
        // toast.info("Cart list cleared");
        // toast.success("Cart list cleared");
        // toast.error("Cart list cleared");
        toast.warning("Cart list cleared");
      } else {
      }
    });
  };

  let selecteditem = ref("");
  let multiclasses = {
    clear: "",
    clearIcon: "",
  };


  const appointment = ref({});
  const pos_medicines = ref([]);
  const fetchAppointmentDetails = async (app_cust_id = '') => {
    console.log('asdjfskdfksdl==', [app_cust_id, queryAppointmentId]);
    removePresSaleAllCartItems();
    if(!app_cust_id && !queryAppointmentId) return;
    const formData = new FormData();
    formData.append('appointment_id', queryAppointmentId);
    formData.append('type', queryType);
    formData.append('app_cust_id', app_cust_id);

    const res = await axios.post(app2.apiUrl + '/hm/generate-prescription-sale-create', formData, app2.headers);
    const data = res.data.data;
    appointment.value = data.appointment;
    pos_medicines.value = data.pos_medicines;
    data.pos_medicines.forEach((item) => {
      store.dispatch("addPresSaleCartItem", item);
    });
    querySearchCode.value = "";
    form.value.appointment_id = data.appointment.id;
    form.value.customer_id = data.appointment.patient_id;
    form.value.patient_name = data.appointment.patient_name;

  }

  let scanTimeout = null;
  const appointmentSearchByCode = (event) => {
    clearTimeout(scanTimeout);
    scanTimeout = setTimeout(() => {
    const code = event.target.value.trim();
    if (code.length >= 5) { // adjust min length
      fetchAppointmentDetails(code);
    }
    }, 300); // scanners type very fast
  };

  const fetchCustomers = async () => {
    axios.get(app2.apiUrl + "/customers", app2.headers).then((res) => {

      console.log("res.customers", res.data.data);
      state.customers = res.data.data.map(
        ({
          id,
          name,
          discount_percent,
          customer_group_discount,
          customer_group_id,
          customer_group_name,
          available_point,
          address,
          phone,
        }) => ({
          label: name,
          value: id,
          discount: discount_percent,
          group_discount: customer_group_discount,
          customer_group_id: customer_group_id,
          customer_group_name: customer_group_name,
          points: available_point,
          address: address,
          phone: phone,
        })
      );
    });
  };

  const districtChange = (event) => {
    axios
      .get(
        app2.apiUrl + "/district-areas/" + event.target.value,
        app2.headers
      )
      .then((res) => {
        state.areas = res.data.data.areas;
      });
  };

  onMounted(async () => {
    handleResize();
    await fetchCustomers();
    await axios
      .get(app2.apiUrl + "/sale-helper", app2.headers)
      .then((res) => {
        state.customer_groups = res.data.data.customer_groups;
        state.districts = res.data.data.districts;
        state.wallets = res.data.data.wallets;
        state.banks = res.data.data.banks;
        state.units = res.data.data.units;
        state.points_setting = res.data.data.points_settings;
      });


    document.addEventListener("keydown", e => {
      if (e.altKey && e.key == 'Enter') {
        if (!submitDisable.value) {
          addConfirmModal();
        } else {
          toast.warning("Collection amount can't be less then net amount!");
        }
      }

      if (e.shiftKey && e.key == 'Enter') {
        handleSubmit();
      }
      // console.log("event code", e.keyCode);
    });
    await fetchCostCenters();
    await fetchAppointmentDetails();

  });

  const appendMessage = (message) => {
    switch (message.type) {
      case "result":
        // resultValue.value = message.format + ": " + message.text;
        resultValue.value = message.text;
        // if(message.text) {
        //   bShowScanner.value = false;
        // }
        break;
      case "error":
        resultValue.value = message.msg;
        break;
      default:
        break;
    }
  };

  // Reactive state
  const getItems = ref("");
  const customer = ref("");
  const invoice_info = ref("");
  const hold_data = ref("");
  const invoice_number = ref("");
  const customer_points = ref(0);
  const isSubmit = ref(false);
  const couponSubmit = ref(false);
  const invDisabled = ref(false);
  const items = ref([]);
  const outlets = ref([]);
  const units = ref([]);
  const cost_centers = ref([]);
  const costCenterOptions = ref([]);
  const valueConsistsOf = ref('BRANCH_PRIORITY');
  const renderOptionComponent = ref(true);
  const editMode = ref(false);
  const more_payemnts = ref([]);
  const winSize = ref({
    width: 0,
    height: 0,
  });
  const discountOverwrite = ref(0);
  const itemsDiscount = ref(0);
  const items_discount_percent = ref(0);
  const enabledDiscount = ref(false);
  const submitDisable = ref(true);
  const special_discount = ref(0);
  const errors = ref("");
  const popupError = ref("");
  const btn_disabled = ref(false);
  const searchDebounceTimer = ref(null);

  const paying_by = ref([
    { value: "cash", name: "Cash", disabled: false },
    { value: "gift_card", name: "Gift Card", disabled: false },
    { value: "redeem_point", name: "Redeem", disabled: false },
    { value: "CC", name: "Credit Card", disabled: false },
    { value: "mfs", name: "Mobile wallet", disabled: false },
    { value: "other", name: "Other", disabled: false },
  ]);

  const cform = ref(new Form({
    id: "",
    customer_code: "C" + Math.floor(Math.random() * 100000),
    company_id: 0,
    customer_group_id: 1,
    name: "",
    email: "",
    phone: "",
    gender: "male",
    dob: "",
    district_id: "0",
    area_id: "0",
    postal_code: "",
    discount_percent: 0,
    wholesale_customer: 0,
    sale_without_vat: 0,
    credit_customer: 0,
    store_customer: 0,
    status: 1,
    customer_receivable_account: '',
  }));

  const user = ref(new Form({
    email: "",
    password: "",
  }));

  const form = ref(new Form({
    appointment_id:"",
    order_discount: 0,
    order_vat: 0,
    customer_id: 1,
    patient_name: "",
    coupons_code: "",
  }));

  const pform = ref(new Form({
    order_discount: 0,
    order_vat: 0,
    order_items_vat: 0,
    sale_note: "",
    staff_note: "",
    customer_id: 1,
    customer_name: "",
    items: "",
    total_amount: 0,
    grand_total: 0,
    customer_discount: 0,
    customer_group_discount: 0,
    customer_group_id: '',
    customer_group_name: '',
    total_collect_amount: 0,
    paid_amount: 0,
    return_amount: 0,
    order_discount_value: 0,
    status: "",
    payments: [
      {
        amount: 0,
        paid_by: "cash",
        gift_card: "",
        bank_id: "",
        card_reference_code: "",
        wallet_id: "",
        payment_note: "",
        redeem_point: "",
      },
    ],
  }));
  const searchItem = ref("");
  const arrowCounter = ref(-1);
  const searchProduct = ref([]);
  const singleProductItem = ref("");
  const couponDiscoun = ref(0);
  const eventTimeForScanner = ref("");
  const barcode = ref("");
  const returnInfo = ref("");
  const return_replace = ref([]);
  const sale_return_info = ref({ return_amount: "", return_reason: "" });
  const renderBarcodeReader = ref(false);
  const barcoderRrenderCounter = ref(0);

  const replaceItem = (item_id) => { }

  // Cost Center Data
  const fetchCostCenters = async () => {
    axios.get(app2.apiUrl + '/cost_centers', app2.headerjson)
      .then((res) => {
        cost_centers.value = res.data.data.cost_centers;
        costCenterOptions.value = res.data.data.cost_center_options;
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      });
  }

  const findInvoice = (type = "") => {
    popupError.value = "";
    invDisabled.value = true;
    return_replace.value = [];
    if (type == "return") {
      var postEvent = axios.get(
        app2.apiUrl + "/saleInfo?invoice_number=" + invoice_number.value + '&type=' + type,
        app2.headerjson
      );
    } else {
      postEvent = axios.get(
        app2.apiUrl + "/saleInfo?invoice_number=" + invoice_number.value,
        app2.headerjson
      );
    }
    postEvent
      .then((res) => {
        invDisabled.value = false;
        if (res.status == 200) {
          if (res.data.data.length > 0) {
            if (returnReplaceModalActive.value) {
              popupError.value = "";
              returnReplaceModalActive.value = false;
              returnReplacePageModalActive.value = true;
              returnInfo.value = res.data.data[0];
              res.data.data[0].sales_items.forEach((item) => {

                let current_discount_percent = Number((item.discount / item.mrp_price) * 100).toFixed(2);
                item.return_discount_percent = current_discount_percent;
                const newObj = {
                  item_id: item.id,
                  pro_id: item.product_id,
                  replace_pro_id: "",
                  new_pro_id: "",
                  replace_stock_id: "",
                  item_qty: item.quantity,
                  return_qty: "",
                  replace_mrp_price: item.mrp_price,
                  replace_cost_price: 0,
                  replace_discount: item.discount,
                  return_discount_percent: current_discount_percent,
                  replace_vat: 0,
                  replace_vat_id: 0,
                  return_or_replace: "",
                };
                return_replace.value.push(newObj);
              });
            } else if (saleReplaceModalActive.value) {
              popupError.value = "";
              saleReplaceModalActive.value = false;
              saleReplacePageModalActive.value = true;
              //invoiceModal()
              //invoice_info.value = res.data.data[0];
              returnInfo.value = res.data.data[0];
              res.data.data[0].sales_items.forEach((item) => {
                const newObj = {
                  item_id: item.id,
                  pro_id: item.product_id,
                  replace_pro_id: "",
                  new_pro_id: "",
                  replace_stock_id: "",
                  item_qty: item.quantity,
                  return_qty: "",
                  replace_mrp_price: item.mrp_price,
                  replace_cost_price: 0,
                  replace_discount: item.discount,
                  replace_vat: 0,
                  replace_vat_id: 0,
                  return_or_replace: "",
                };
                return_replace.value.push(newObj);
              });
            } else if (rePrintModalActive.value) {
              popupError.value = "";
              rePrintModalActive.value = false;
              invoiceModal();
              invoice_info.value = res.data.data[0];
            }
          } else {
            popupError.value = "Please enter valid invoice number";
            //toast.error('Please enter valid invoice number');
          }
        } else {
          popupError.value = res.data.message;
          // toast.error(res.data.message);
        }

      })
      .catch((err) => {
        console.log("err", err);
        invDisabled.value = false;
        popupError.value = err.response.data.message;

        setTimeout(() => {
          popupError.value = "";
        }, 3000)
        // toast.error(err.response.data.message);
      });
  }

  const itemReturnOrReplace = (value, index) => {
    // 0 = Return
    // 1 = Replace
    return_replace.value[index].replace_pro_id = "";
    return_replace.value[index].return_qty = "";
  };

  const checkReturnQuantity = (value, index, sold_quantity) => {
    if (Number(value) > Number(sold_quantity)) {
      return_replace.value[index].return_qty = "";
      toast.error("Return quantity can't be greater than sold quantity!");
    }
  };

  const returnDiscountApply = (value, index, item) => {
    let discount = ((item.mrp_price * value) / 100).toFixed(2);
    item.discount = discount;
    return_replace.value[index].replace_discount = discount;
  }

  const onChangeReplaceProduct = (event, index) => {
    var id_value = event;
    var separator = id_value.split("___");
    var sproduct_id = separator[0];
    var stock_id = separator[1];
    var product_item = this.$store.getters.productItems.find(
      ({ product_id, product_stock_id }) =>
        product_id == sproduct_id && product_stock_id == stock_id
    );

    return_replace.value[index].new_pro_id = product_item.product_id;
    return_replace.value[index].return_qty = "";
    return_replace.value[index].replace_stock_id = product_item.product_stock_id;
    return_replace.value[index].replace_mrp_price = product_item.mrp_price;
    return_replace.value[index].replace_cost_price = product_item.cost_price;
    return_replace.value[index].replace_discount = product_item.item_discount;
    return_replace.value[index].replace_vat = product_item.tax;
    return_replace.value[index].replace_vat_id = product_item.product_tax;
  }

  const voidInvoice = () => {
    var rrdata = {
      sale_return_info: sale_return_info.value,
      returnInfo: returnInfo.value,
      return_replace: return_replace.value,
    };

    swal({
      title: 'Are you sure?',
      text: "You want void this invoice!",
      showCancelButton: true,
      confirmButtonCategory: '#3085d6',
      cancelButtonCategory: '#d33',
      confirmButtonText: 'Confirm'
    }).then((result) => {
      if (result.value) {
        var postEvent = axios.post(
          app2.apiUrl + "/sale_returns_void",
          rrdata,
          app2.headerjson
        );

        postEvent
          .then((res) => {
            returnReplacePageModal();
            sale_return_info.value = {};
            returnInfo.value = "";
            return_replace.value = [];
            toast.success(res.data.message);
          })
          .catch((err) => {
            toast.error(err);
          });
      }
    });
  };

  const returnAndReplace = () => {
    const returnAmt = Number(sale_return_info.value && sale_return_info.value.return_amount ? sale_return_info.value.return_amount : 0);
    if (returnAmt <= 0) {
      toast.warning("Return amount must be greater than 0");
      return false;
    }

    const hasInValidReturn = return_replace.value.some(item =>
      item.return_or_replace && (item.return_qty == "" || Number(item.return_qty) == 0)
    );

    if (hasInValidReturn) {
      toast.warning("Please select at least one item with return quantity");
      return false;
    }

    var rrdata = {
      sale_return_info: sale_return_info.value,
      returnInfo: returnInfo.value,
      return_replace: return_replace.value,
    };

    swal({
      title: 'Are you sure?',
      text: "You want return sales item!",
      showCancelButton: true,
      confirmButtonCategory: '#3085d6',
      cancelButtonCategory: '#d33',
      confirmButtonText: 'Confirm'
    }).then((result) => {
      if (result.value) {
        var postEvent = axios.post(
          app2.apiUrl + "/sale_returns",
          rrdata,
          app2.headerjson
        );
        postEvent
          .then((res) => {
            returnReplacePageModal();
            sale_return_info.value = {};
            returnInfo.value = "";
            return_replace.value = [];
            toast.success(res.data.message);
          })
          .catch((err) => {
            toast.error(err.response.data.message);
          });
      }
    });
  };

  const saleReplace = () => {
    var rrdata = {
      sale_return_info: sale_return_info.value,
      returnInfo: returnInfo.value,
      return_replace: return_replace.value,
    };
    var postEvent = axios.post(
      app2.apiUrl + "/sale_replaces",
      rrdata,
      app2.headerjson
    );
    postEvent
      .then((res) => {
        // returnReplacePageModal();
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  const checkStockQty = (product_item) => {
    if (product_item.quantity > product_item.stock_quantity) {
      toast.error("Your item quantity can't getter than " + product_item.stock_quantity, { position: "top-left" });
      product_item.quantity = 1;
    }
  };

  const checkItem = (item) => {
    for (var i = 0; i < pform.value.payments.length; i++) {
      if (pform.value.payments[i].paid_by == item) {
        return true;
      }
    }
  };

  const onkeyPress = (field) => {
    for (var k in errors.value) {
      if (k == field) {
        delete errors.value[k];
      }
    }
  };

  const validateNumber = (event) => {
    var RE = /^[0-9]*\.?[0-9]*$/;
    let charCode = String.fromCharCode(event.keyCode);
    if (!RE.test(charCode)) {
      toast.warning("Please press valid amount");
      event.preventDefault();
    }
  };

  const checkAboveAmount = (event, i) => {
    if (form.value.customer_id == 1) {
      if (totalCollections.value > Number(netAmountCalculate.value)) {
        submitDisable.value = false;
      } else {
        submitDisable.value = true;
      }
    }
    var mask = document.getElementById(
      "payingby_" + event.target.id.split("_")[1]
    );
    if (mask.value != "cash") {
      if (Number(netAmountCalculate.value) < Number(event.target.value)) {
        event.target.value = netAmountCalculate.value;
        if (i == 's') {
          pform.value.payments[0].amount = netAmountCalculate.value;
        }
        toast.warning("Not allow max amount ");
      }
    }
  };

  const morePayemnt = () => {
    let paymentsPaid_by = [];
    for (var i = 0; i < pform.value.payments.length; i++) {
      paymentsPaid_by.push(pform.value.payments[i].paid_by);
    }
    let paid_by = "";
    for (var p = 0; p < paying_by.value.length; p++) {
      if (paymentsPaid_by.indexOf(paying_by.value[p].value) == -1) {
        paid_by = paying_by.value[p].value;
        break;
      }
    }
    paymentsPaid_by.splice(0);
    let r = (Math.random() + 1).toString(36).substring(7);
    const newPayment = { id: r };
    if (!paid_by) {
      toast.error("Payment type not available");
    } else {
      const newObj = {
        amount: 0,
        paid_by: paid_by,
        gift_card: "",
        bank_id: "",
        card_reference_code: "",
        wallet_id: "",
        payment_note: "",
        redeem_point: "",
      };
      more_payemnts.value.push(newPayment);
      pform.value.payments.push(newObj);
    }
  };

  const morePayemntRemove = (index) => {
    more_payemnts.value.splice(index, 1);
    pform.value.payments.splice(index + 1, 1);
  };

  const handleLogin = () => {
    isSubmit.value = true;
    var postEvent = axios.post(
      app2.apiUrl + "/auth/unlockDiscount",
      user.value,
      app2.headerjson
    );
    postEvent
      .then((res) => {
        isSubmit.value = false;
        disabled.value = false;
        if (res.data) {
          if (res.data.data.discount) {
            enabledDiscount.value = true;
          } else {
            toast.error("Discount are not allowed for you");
          }
        }
      })
      .catch((err) => {
        isSubmit.value = false;
        disabled.value = false;
        toast.error(err.response.data.message);
      });
  };

  const handleSubmit = () => {
    isSubmit.value = true;
    btn_disabled.value = true;
    pform.value.items = JSON.parse(
      JSON.stringify(store.getters.presCartItems)
    );
    pform.value.order_discount = form.value.order_discount;
    pform.value.appointment_id = form.value.appointment_id;
    pform.value.customer_id = form.value.customer_id;
    pform.value.customer_name = (form.value.customer_id == 1) ? form.value.default_customer_name : "";
    pform.value.hold_sale_info = store.getters.holdPresSaleInfo;

    let extraMoney = Number(Math.round(pform.value.grand_total) - Math.round(totalCollections.value));
    if (extraMoney < 0) {
      pform.value.paid_amount = pform.value.grand_total;
      pform.value.status = "paid";
      if (!checkItem('cash')) {
        if (totalCollections.value <= Math.round(pform.value.grand_total)) {
          // Continue
        } else {
          toast.warning('Collection amount violate');
          isSubmit.value = false;
          btn_disabled.value = false;
          return false;
        }
      } else {
        let checkCollectionAmount = 0;
        for (var i = 0; i < pform.value.payments.length; i++) {
          if (pform.value.payments[i].paid_by != 'cash') {
            checkCollectionAmount += parseFloat(pform.value.payments[i].amount);
          }
        }
        if (checkCollectionAmount >= pform.value.grand_total) {
          toast.warning('Collection amount violate');
          isSubmit.value = false;
          btn_disabled.value = false;
          return false;
        }
      }
    } else if (extraMoney == 0) {
      pform.value.status = "paid";
      pform.value.paid_amount = totalCollections.value;
      pform.value.total_collect_amount = totalCollections.value;
    } else if ((Math.round(pform.value.grand_total) > Math.round(totalCollections.value)) && (Math.round(totalCollections.value) != 0)) {
      pform.value.status = "partial";
      pform.value.paid_amount = totalCollections.value;
      pform.value.total_collect_amount = totalCollections.value;
      extraMoney = 0;
    } else {
      pform.value.status = "due";
      pform.value.paid_amount = totalCollections.value;
      pform.value.total_collect_amount = totalCollections.value;
      extraMoney = 0;
    }
    pform.value.return_amount = Math.abs(extraMoney);

    // console.log("pformmm===", JSON.parse(JSON.stringify(pform.value)));

    const payload_data = JSON.parse(JSON.stringify(pform.value));

    var postEvent = editMode.value ?
      axios.put(app2.apiUrl + "/sales-with-account-transaction/" + form.value.id, payload_data, app2.headerjson) :
      axios.post(app2.apiUrl + "/sales-with-account-transaction", payload_data, app2.headerjson);

    postEvent
      .then((res) => {
        isSubmit.value = false;
        btn_disabled.value = false;
        if (res.status == 200) {
          invoice_info.value = res.data.data[0];
          invoiceModal();
          if (invoiceModalActive.value) {
            setTimeout(() => {
              print("invoice-POS");
            }, 3000);
          }
          if (paymentModalActive.value) {
            paymentModal();
          }
          if (confirmModalActive.value) {
            addConfirmModal();
          }
          if (Math.round(pform.value.return_amount) != 0) {
            swal({
              html: "<h3 style='color:red'>" + Math.round(pform.value.return_amount).toLocaleString() + "</h3>",
              title: "Return Amount",
              confirmButtonCategory: "#3085d6",
              cancelButtonCategory: "#d33",
              confirmButtonText: "Ok!",
            });
          }
          more_payemnts.value = [];
          items_discount_percent.value = 0;
          pform.value.reset?.();
          cform.value.reset?.();
          form.value.reset?.();
          toast.success(res.data.message);
          store.dispatch("removePresSaleAllCartItems");
          // axios.get(app2.apiUrl + "/posproducts", app2.headers)
          //   .then((res) => {
          //     store.commit("UPDATE_PRODUCT_ITEMS", res.data.data);
          //   });
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        const msg =
        err.response?.data?.message ||
        err.message ||
        'Something went wrong';

        toast.error(msg);
        isSubmit.value = false;
        btn_disabled.value = false;
      });
  };

  const handleSaleHoldSubmit = () => {
    isSubmit.value = true;
    pform.value.items = JSON.parse(JSON.stringify(store.getters.presCartItems));
    pform.value.order_discount = form.value.order_discount;
    pform.value.customer_id = form.value.customer_id;
    pform.value.hold_sale_info = store.getters.holdPresSaleInfo;

    var postEvent = editMode.value ?
      axios.put(app2.apiUrl + "/hold_sales/" + form.value.id, pform.value, app2.headerjson) :
      axios.post(app2.apiUrl + "/hold_sales", pform.value, app2.headerjson);

    postEvent
      .then((res) => {
        isSubmit.value = false;
        disabled.value = false;
        if (res.status == 200) {
          if (paymentModalActive.value) {
            paymentModal();
          }
          if (confirmModalActive.value) {
            addConfirmModal();
          }
          pform.value.reset?.();
          cform.value.reset?.();
          form.value.reset?.();
          toast.success(res.data.message);
          store.dispatch("removePresSaleAllCartItems");
          // axios.get(app2.apiUrl + "/posproducts", app2.headers)
          //   .then((res) => {
          //     store.commit("UPDATE_PRODUCT_ITEMS", res.data.data);
          //   });
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        isSubmit.value = false;
        disabled.value = false;
      });
  };

  const searchPosProducts = (event) => {
    if (['ArrowUp', 'ArrowDown', 'Enter'].includes(event.code)) return;
    const query = event.target.value?.trim();
    clearTimeout(searchDebounceTimer.value);
    searchDebounceTimer.value = setTimeout(() => {
      if (!query) {
        arrowCounter.value = -1;
        searchProduct.value = [];
        return;
      }

      axios.get(app2.apiUrl + "/posproducts?search=" + query, app2.headers)
        .then((res) => {
          if (res.status == 200) {
            var filtered = res.data.data;
            if (filtered.length == 1) {
              setResult(filtered[0]);
              searchItem.value = "";
              searchProduct.value.splice(0);
            }
            searchProduct.value = filtered;
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    }, 500);
  };

  const onArrowDown = (event) => {
    if (searchProduct.value.length > 0) {
      arrowCounter.value = event.code == "ArrowDown" ? ++arrowCounter.value : --arrowCounter.value;
      if (arrowCounter.value >= searchProduct.value.length)
        arrowCounter.value = arrowCounter.value % searchProduct.value.length;
      else if (arrowCounter.value < 0)
        arrowCounter.value = searchProduct.value.length + arrowCounter.value;
      selectProduct(searchProduct.value[arrowCounter.value]);
      singleProductItem.value = searchProduct.value[arrowCounter.value];
    }
  };

  const onArrowUp = (event) => {
    if (searchProduct.value.length > 0) {
      arrowCounter.value = event.code == "ArrowUp" ? --arrowCounter.value : ++arrowCounter.value;
      if (arrowCounter.value >= searchProduct.value.length)
        arrowCounter.value = arrowCounter.value % searchProduct.value.length;
      else if (arrowCounter.value < 0)
        arrowCounter.value = searchProduct.value.length + arrowCounter.value;
      selectProduct(searchProduct.value[arrowCounter.value]);
      singleProductItem.value = searchProduct.value[arrowCounter.value];
    }
  };

  const selectProduct = (item) => {
    searchItem.value = item.product_name + " (" + item.product_code + ")";
  };

  const setResult = (item) => {
    store.dispatch("addPresSaleCartItem", item);
    searchItem.value = "";
    searchProduct.value.splice(0);
  };

  const addProductToCart = () => {
    if (singleProductItem.value != "") {
      store.dispatch("addPresSaleCartItem", singleProductItem.value);
    } else {
      toast.warning("Product not found!");
    }
    singleProductItem.value = "";
    searchItem.value = "";
    searchProduct.value = [];
  };

  const toggleReadonly = (event) => {
    event.preventDefault();
    if (event.target.getAttribute("readonly") == "readonly") {
      event.target.removeAttribute("readonly");
    } else {
      event.target.setAttribute("readonly", "readonly");
    }
  };

  const payingBy = (e) => {
    var mask = document.getElementById("amount_" + e);
    if (pform.value.payments[e].paid_by == "redeem_point") {
      mask.readOnly = true;
    } else {
      mask.readOnly = false;
    }
  };

  const payingByAnother = (event, e) => {
    if (pform.value.payments[e].paid_by != "cash") {
      paymentModal();
    }
    pform.value.payments[0].paid_by = pform.value.payments[e].paid_by;
    var mask = document.getElementById("amount_" + e);
    if (pform.value.payments[e].paid_by == "redeem_point") {
      mask.readOnly = true;
    } else {
      mask.readOnly = false;
    }
  };

  const redeemPointCheck = (event, e) => {
    if (pform.value.payments[e].redeem_point > customer.value.points) {
      pform.value.payments[e].amount = convartRate.value * customer.value.points;
      pform.value.payments[e].redeem_point = customer.value.points;
    } else {
      pform.value.payments[e].amount = parseFloat(
        Number(convartRate.value * pform.value.payments[e].redeem_point).toLocaleString()
      );
    }
  };

  const applyCoupons = () => {
    var YmdFormat = new Date().toJSON().slice(0, 10).replace(/-/g, "-");
    if (!form.value.coupons_code) {
      toast.error("Please enter your coupon code");
      return false;
    }
    couponSubmit.value = true;
    axios.get(app2.apiUrl + "/coupons/?code=" + form.value.coupons_code, app2.headers)
      .then((res) => {
        couponSubmit.value = false;
        form.value.coupons_code = "";
        couponDiscoun.value = 0;
        if (res.status == 200) {
          if (res.data.data.length > 0) {
            if (res.data.data[0].expires_at >= YmdFormat) {
              if (res.data.data[0].is_fixed) {
                couponDiscoun.value = res.data.data[0].discount_amount;
              } else {
                couponDiscoun.value = (totalCartValue.value * parseFloat(res.data.data[0].discount_amount)) / 100;
              }
              toast.success("Coupon applied");
            } else {
              toast.error("Expired coupon");
            }
          } else {
            toast.error("Please enter valid coupon code");
          }
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        couponSubmit.value = false;
        toast.error(err.response.data.message);
        if (err.response.status == 422) {
          errors.value = err.response.data.errors;
        }
      });
  };

  const handleTax = () => {
    taxModal();
  };

  const selectCustomer = (event) => {
    customer.value = state.customers.find((e) => e.value == event);
    pform.value.customer_id = customer.value.id;
    pform.value.customer_group_id = customer.value.customer_group_id;
    pform.value.customer_group_name = customer.value.customer_group_name;
    if (pform.value.customer_id == 1) {
      totalCollections.value = pform.value.payments[0].amount;
    }
  };

  const handleCustomer = () => {
    isSubmit.value = true;
    axios.post(app2.apiUrl + "/customers", cform.value, app2.headerjson)
      .then((res) => {
        if (res.status == 200) {
          isSubmit.value = false;
          cform.value.reset?.();
          form.value.customer_id = res.data.data.id;
          pform.value.customer_id = res.data.data.id;
          fetchCustomers();
          customerModal();
          toast.success(res.data.message);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        isSubmit.value = false;
        toast.error(err.response.data.message);
        if (err.response.status == 422) {
          errors.value = err.response.data.errors;
        }
      });
  };

  const handleResize = () => {
    winSize.value.width = window.innerWidth;
    winSize.value.height = window.innerHeight - 160;
    var b = document.querySelector("body");
    var mask = document.getElementById("leftside-menu-container");
    if (b.hasAttribute("data-leftbar-compact-mode")) {
      mask.style.overflowY = "auto";
      b.removeAttribute("data-leftbar-compact-mode");
      document.getElementsByTagName("body")[0].classList.add("sidebar-enable");
      document.getElementsByTagName("body")[0].classList.remove("compact-enable");
    } else {
      mask.style.overflowY = "visible";
      b.setAttribute("data-leftbar-compact-mode", "condensed");
      document.getElementsByTagName("body")[0].classList.remove("sidebar-enable");
      document.getElementsByTagName("body")[0].classList.add("compact-enable");
    }
  };

  const deleteItem = (item) => {
    items.value.splice(items.value.indexOf(item), 1);
  };

  const random_num = (min = 4, max = 6) => {
    const result = "C" + Math.floor(Math.random() * 100000);
    cform.value.customer_code = result;
  };

  const ledgerAccountNameSetup = (value) => {
    cform.value.customer_receivable_account = value;
  };

  const print = (document_id) => {
    const options = {
      name: '_blank',
      specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
      styles: [
        app2.baseUrlPrintCSS + '/assets/css/bootstrap-print.min.css',
        app2.baseUrlPrintCSS + '/assets/css/print.css'
      ],
    };
    app2.$htmlToPaper(document_id, options);
  };

  const itemDiscountPlat = (item, index) => {
    let percent = 0;
    if (item.uom == 5) {
      percent = (parseFloat(item.discount) / (item.weight * item.mrp_price)) * 100;
    } else {
      percent = (parseFloat(item.discount) / (item.quantity * item.mrp_price)) * 100;
    }
    store.getters.presCartItems[index].discount_percent = percent.toFixed(2);
  };

  const itemDiscountPercent = (item, index) => {
    let order_discount = 0;
    if (item.uom == 5) {
      order_discount = ((item.mrp_price) * (parseFloat(item.discount_percent)) / 100);
    } else {
      order_discount = ((item.mrp_price) * (parseFloat(item.discount_percent)) / 100);
    }
    store.getters.presCartItems[index].discount = order_discount;
    store.getters.presCartItems[index].item_discount = order_discount;
  };

  const allItemDiscountPercent = () => {
    var data_count = store.getters.presCartItems.length;
    for (var i = 0; i < data_count; i++) {
      store.getters.presCartItems[i].discount_percent = items_discount_percent.value;
      itemDiscountPercent(store.getters.presCartItems[i], i);
    }
  };

  const printItem = () => {
    printContent('printArea');
  }

  const printContent = (document_id) => {
    const options = {
      name: '_blank',
      specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
      styles: [
        app2.baseUrlPrintCSS + '/assets/css/bootstrap-print.min.css',
        app2.baseUrlPrintCSS + '/assets/css/print.css'
      ],
    };
    app2.$htmlToPaper(document_id, options);
  }

  // Watch for updates
  onBeforeUpdate(() => {
    if (totalCartValue.value > 0 && form.value.customer_id) {
      disabled.value = false;
    } else {
      disabled.value = true;
    }
    if (!discountModalActive.value) {
      enabledDiscount.value = false;
    }

    if (!rePrintModalActive.value) {
      invoice_number.value = "";
      popupError.value = "";
    }

    if (!returnReplaceModalActive.value) {
      popupError.value = "";
    }

    if (!returnReplacePageModalActive.value) {
      returnInfo.value = "";
      return_replace.value = [];
    }

    if (state.customers.length > 0) {
      customer.value = state.customers.find(
        (e) => e.value == form.value.customer_id
      );

      pform.value.customer_group_id = customer.value ? customer.value.customer_group_id : '';
      pform.value.customer_group_name = customer.value ? customer.value.customer_group_name : '';
    }

    if (!barcodeReaderModalActive.value) {
      if (renderBarcodeReader.value) {
        // this.stopRead();
      }
    } else {
      // this.startRead();
    }

    if (netAmountCalculate.value > 0) {
      submitDisable.value = false;
      btn_disabled.value = false;
    } else {
      submitDisable.value = true;
      btn_disabled.value = true;
    }

    if (pform.value.customer_id == 1) {
      totalCollections.value = pform.value.payments[0].amount;
      if (Number(totalCollections.value) >= Number(netAmountCalculate.value)) {
        submitDisable.value = false;
      } else {
        submitDisable.value = true;
      }
    } else {
      submitDisable.value = false;
    }

    if (paymentModalActive.value === false) {
      more_payemnts.value = [];
      pform.value.payments.splice(1);
    }
  });

  // Computed properties
  const totalItemQty = computed(() => {
    return store.getters.presCartItems.reduce((total, item) => {
      return total + item.quantity;
    }, 0);
  });

  const totalItemWeight = computed(() => {
    return store.getters.presCartItems.reduce((total, item) => {
      return total + item.weight;
    }, 0);
  });

  const totalItemPrice = computed(() => {
    return store.getters.presCartItems.reduce((total, item) => {
      return total + item.mrp_price;
    }, 0);
  });

  const totalItemValue = computed(() => {
    return store.getters.presCartItems.reduce((total, item) => {
      if (item.uom == 5) {
        return total + item.weight * item.mrp_price;
      } else {
        return total + item.quantity * item.mrp_price;
      }
    }, 0);
  });

  const totalItemDiscount = computed(() => {
    return store.getters.presCartItems.reduce((total, item) => {
      return total + item.discount;
    }, 0);
  });

  const totalItemDiscountValue = computed(() => {
    return store.getters.presCartItems.reduce((total, item) => {
      let subtotal = 0;
      let item_weight = item.weight ? item.weight : 0;
      if (item.uom == 5) {
        subtotal = parseFloat(item.discount) * parseFloat(item_weight).toFixed(0);
      } else {
        subtotal = parseFloat(item.discount) * parseFloat(item.quantity).toFixed(0);
      }
      return total + subtotal;
    }, 0);
  });

  const totalItemNetValue = computed(() => {
    return store.getters.presCartItems.reduce((total, item) => {
      let results;
      if (item.uom == 5) {
        results = parseFloat(item.mrp_price * item.weight - (item.discount * item.weight)).toFixed(2);
      } else {
        results = parseFloat(item.mrp_price * item.quantity - (item.discount * item.quantity)).toFixed(2);
      }
      return total + Number(results);
    }, 0);
  });

  const totalCollections = computed(() => {
    return pform.value.payments.reduce((total, item) => {
      return total + parseFloat(item.amount);
    }, 0);
  });

  const num = (v) => Number(v) || 0;

  const netAmountCalculate = computed(() => {

    const totalDiscount =
    num(all_discount.value) +
    num(specialDiscount.value) +
    num(customer_group_discount.value) +
    num(customer_discount.value) +
    num(couponDiscoun.value);
    
    const totalVatTax =
    num(invoiceVat.value) +
    num(totalCartTax.value);
    
    console.log(totalCartValue.value, all_discount.value, specialDiscount.value, customer_group_discount.value, 
    customer_discount.value, couponDiscoun.value, invoiceVat.value, totalCartTax.value)
    const totalCart = num(totalCartValue.value);

    const result = (totalCart + totalVatTax - totalDiscount).toFixed(2);

    // console.log(totalDiscount, totalVatTax, result);
    pform.value.grand_total = result;
    pform.value.order_items_vat = num(totalCartTax.value);
    pform.value.total_amount = totalCart.toFixed(2);
    pform.value.payments[0].amount = result;

    return result;
  });

  // const netAmountCalculate = computed(() => {
  //   let totalDiscount = all_discount.value + specialDiscount.value + customer_group_discount.value + customer_discount.value + couponDiscoun.value;
  //   let totalVatTax = invoiceVat.value + totalCartTax.value;
  //   let result = parseFloat(totalCartValue.value + totalVatTax - totalDiscount).toFixed(2);

  //   console.log(totalDiscount, totalVatTax, result);
  //   pform.value.grand_total = result;
  //   pform.value.order_items_vat = totalCartTax.value;
  //   pform.value.total_amount = parseFloat(totalCartValue.value).toFixed(2);
  //   pform.value.payments[0].amount = parseFloat(result).toFixed(2);
  //   return parseFloat(result).toFixed(2);
  // });

  const salesReturnAmountSumVal = computed(() => {
    let sumTotal = return_replace.value.reduce((total, ritem) => {
      let item_discount = ritem.replace_discount * ritem.return_qty;
      return total + ((ritem.replace_mrp_price * ritem.return_qty) - item_discount);
    }, 0);
    sale_return_info.value.return_amount = sumTotal;
    return sumTotal;
  });

  const specialDiscount = computed(() => {
      let order_discount = 0;
      let checkNumber = !isNaN(form.value.order_discount);
      if (form.value.order_discount) {
        let percentage = form.value.order_discount.split("%");
        if (percentage.length > 1) {
          order_discount = (totalCartValue.value * parseFloat(percentage[0])) / 100;
        } else {
          order_discount = checkNumber ? parseFloat(form.value.order_discount) : 0;
        }
      }
      pform.value.order_discount_value = order_discount;
      return (special_discount.value = order_discount);
  });

  // Computed properties for display
  const customer_discount = computed(() => {
    return customer.value?.discount || 0;
  });

  const customer_group_discount = computed(() => {
    return customer.value?.group_discount || 0;
  });

  const invoiceVat = computed(() => {
    return form.value.order_vat || 0;
  });

  const presCartItems = computed(() => {
    return store.getters.presCartItems;
  });

  const removePresSaleAllCartItems = () => {
    return store.dispatch("removePresSaleAllCartItems");
  };

  const removePresSaleCartItem = (payload) => {
    return store.dispatch("removePresSaleCartItem", payload);
  };

  const addPresSaleCartItem = (payload) => {
    return store.dispatch("addPresSaleCartItem", payload);
  };

</script>


<style scoped>
/* #UIElement {
  margin: 2vmin auto;
  text-align: center;
  font-size: medium;
  height: 40vh;
  width: 80vw;
} */

.inv-perview h2, .inv-perview tr td{
  font-size:11px;
  margin: 0;
  padding: 3px 0;
}
#mid .info p{
  font-size:11px !important
}
.cmb-5{
  margin-bottom:5px !important;
  font-size:11px;
}
.return_amount{
  font-size: 20px;
  font-weight: bold;
  color: #e86969; 
}
#return_amount{ 
  transition: 0.5s;
  animation: blinker 1s linear infinite;
}
@keyframes blinker {
  80% {
    opacity: 0;
  }
}
.form-control.border.coupon {
  height: 32px;
}
#outline-buttons-preview {
  margin: 5px 31px 10px -10px;
}
.w-full.rounded.bg-white.border.border-gray-300.px-4.py-2.space-y-1.absolute.z-10 {
  position: absolute;
  z-index: 9999;
}
.form-group {
  margin-bottom: 5px;
}
.border.success.item-head {
  width: 20px !important;
  color: #f4f4f4;
  background-color: #3e81ae;
}
.table-bordered th,
.table-bordered td {
  border: none;
}
.pos-footer {
  width: 96%;
  margin: 0px auto;
}
.pos-body {
  overflow-x: scroll;
}
.qty {
  width: 71px;
}
.input-group.input-group-merge {
  height: 38px;
}
.input-group-text {
  height: 40px;
}

.btn-square-md {
  width: 100px !important;
  max-width: 100% !important;
  max-height: 100% !important;
  height: 100px !important;
  text-align: center;
  padding: 0px;
  font-size: 12px;
}
.payment {
  width: 560px;
}
.well {
  border: 1px solid #ddd;
  background-color: #f6f6f6;
  box-shadow: none;
  border-radius: 0px;
}
.well-sm {
  padding: 9px;
  border-radius: 3px;
}

/** Autocomplete */
.autocomplete {
  position: relative;
}

ul.autocomplete-results {
  width: 100% !important;
  /* margin-top: 39px !important; */
}
.autocomplete-results {
  padding: 0;
  margin: 0;
  border: 1px solid #eeeeee;
  overflow: auto;
  width: 100%;
}

.autocomplete-results li {
  list-style: none;
  text-align: left;
  padding: 4px 2px;
  cursor: pointer;
}

.autocomplete-results li.isActive,
.autocomplete-results li:hover {
  background-color: #4aae9b;
  color: white;
}
.autocomplete-results li:first-child {
  font-weight: 600;
  border-bottom: 1px solid #282828;
  margin-bottom: 3px;
}
.autocomplete-results li:first-child:hover {
  background-color: inherit;
  color: inherit;
}

.isActive {
  background-color: #dedede;
}

@media print {
  
  body {
      margin: 0;
      padding: 0;
  }

  #invoice-POS {
    border: 2px solid #000;
    background: #3e81ae;
    font-size: 8px !important;
  }
  

  dl,
  ol,
  ul {
    margin-top: 0;
    margin-bottom: 1rem;
    list-style-type: none;
  }

  #invoice-POS {
    box-shadow: 0 0 1in -0.25in rgba(0, 0, 0, 0.5);
    padding: 2mm;
    margin: 0 auto;
    width: 84mm;
    background: #fff;
  }
  #invoice-perview {
    box-shadow: 0 0 1in -0.25in rgba(0, 0, 0, 0.5);
    padding: 2mm;
    margin: 0 auto;
    width: 110mm;
    background: #fff;
    font-size: 7px !important;
  }
  /* .fnt10{
    font-size: 10px !important;
  } */

  .borderTop {
    border-top: 1px solid black !important;
  }
  .borderBottom {
    border-bottom: 1px dashed #ccc !important;
  }
  
}

dl,
ol,
ul {
  list-style-type: none !important;
}

.modal-content.scrollbar-width-thin.customer-add-modal {
  width: 85%;
  display: block;
  margin: auto;
}
.modal-content.scrollbar-width-thin.confirm-window {
  width: 100%;
  display: block;
  margin: auto;
}
.modal-content.scrollbar-width-thin.invoice-modal {
  width: 100%;
  display: block;
  margin: auto;
}

.modal-content.scrollbar-width-thin.barcodeReaderModal {
  width: 100%;
  display: block;
  margin: auto;
}

.modal-content.scrollbar-width-thin.barcodeReaderModal #videoWindow.video {
    width: 100% !important;
}

.modal-content.scrollbar-width-thin.barcodeReaderModal #videoWindow canvas {
    /* width: 500px !important; */
    display: none !important;
}

canvas.drawingBuffer {
    display: none;
}

.modal-content.scrollbar-width-thin.return-replace-modal {
  width: 90%;
  display: block;
  margin: auto;
}
.btn-return {
  background-color: #fe7a00;
  color: #fff;
}
.return-replace-summary h2 {
  margin: 7px auto;
  padding: 0px;
  font-weight: bold;
}

#invoice-POS {
  box-shadow: 0 0 1in -0.25in rgba(0, 0, 0, 0.5);
  padding: 2mm;
  margin: 0 auto;
  width: 84mm;
  background: #fff;
}
#invoice-perview {
  box-shadow: 0 0 1in -0.25in rgba(0, 0, 0, 0.5);
  padding: 2mm;
  margin: 0 auto;
  width: 110mm;
  background: #fff;
}

::selection {
  background: #f31544;
  color: #fff;
}
::moz-selection {
  background: #f31544;
  color: #fff;
}
h1 {
  font-size: 1.5em;
  color: #222;
}
h2 {
  font-size: 0.9em;
}
h3 {
  font-size: 1.2em;
  font-weight: 300;
  line-height: 2em;
}
p {
  font-size: 0.7em;
  color: #666;
  line-height: 1.2em;
}

#top,
#mid,
#bot {
  /* Targets all id with 'col-' 
  border-bottom: 1px solid #eee;*/
}

 
 
#top .logo {
  height: 60px;
  width: 60px;
  background: url(http://michaeltruong.ca/images/logo1.png) no-repeat;
  background-size: 60px 60px;
}
.clientlogo {
  float: left;
  height: 60px;
  width: 60px;
  background: url(http://michaeltruong.ca/images/client.jpg) no-repeat;
  background-size: 60px 60px;
  border-radius: 50px;
}
.info {
  display: block;
  margin-left: 0;
}
.title {
  float: right;
}
.title p {
  text-align: right;
}
table {
  width: 100%;
  border-collapse: collapse;
}
.tabletitle {
  font-size: 0.5em;
}
.service {
  border-bottom: 1px solid #eee;
}
.item {
  width: 30%;
}
.hours {
  width: 10%;
}
.rate {
  width: 10%;
}
.subtotal {
  width: 10%;
}
.action {
  width: 15%;
}
.itemtext {
  font-size: 0.5em;
}

#legalcopy {
  margin-top: 5mm;
}

p {
  font-size: 0.7em;
  color: #000;
  line-height: 1.2em;
}
.borderTop {
  border-top: 1px solid black;
}
.borderBottom {
  border-bottom: 1px dashed #ccc;
}
.Rate h2 {
  margin: 0px;
  padding: 0px;
}

@media only screen and (max-width: 464px) {
  /* For mobile phones: */
  #invoice-perview {
    width: 100%;
  }
}

@media only screen and (max-width: 768px) {
  /* For mobile phones: */
  .pos-body {
    min-height: 150px !important;
    height: auto !important;
    margin-bottom: 20px;
  }

  .pos-leftbar {
    margin-bottom: 20px;
  }
}

@media only screen and (max-width: 1330px) {
  /* For mobile phones: */
  .coupon_box {
    width: 100% !important;
  }
}

@media only screen and (min-width: 940px) and (max-width: 1330px) {
  /* For mobile phones: */
  .action_btn {
    width: 50% !important;
  }
}

@media only screen and (min-width: 769px) and (max-width: 939px) {
  /* For mobile phones: */
  .action_btn {
    width: 100% !important;
  }
}
</style>

<style>
  .modal-content.scrollbar-width-thin.barcodeReaderModal #videoWindow video {
    width: 100% !important;
}

.modal-content.scrollbar-width-thin.barcodeReaderModal #videoWindow canvas {
    /* width: 500px !important; */
    display: none !important;
}

canvas.drawingBuffer {
    display: none;
}
</style>
